import { d as __extends, e as __awaiter, f as __generator, a as __spreadArray, _ as __read, b as __assign, g as __rest } from './tslib.es6-14c74580.js';
import { makeObservable, observable, action, flow, computed } from 'mobx';
import { HubConnectionState, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { CommonConnectionsMethod, GameLiveConnectionMethod, ConnectionPrefix, LobbyLiveConnectionMethod } from './shared/core/services/liveConnection/types.js';
import { HttpResponse } from './shared/core/classes/httpResponse/index.js';
import { chatStore } from './shared/core/store/chatStore.js';
import { gameResultStore } from './shared/core/store/gameResultStore.js';
import { environmentBuilder } from './shared/core/helpers/environmentBuilder.js';
import axios__default from 'axios';
import { parseQuery } from './shared/core/helpers/parseQuery.js';
import './shared/core/enums/GameSpecificTypes.js';
import './shared/core/enums/Chat.js';
import './shared/core/enums/GameModes.js';
import './shared/core/enums/IconTypes.js';
import './shared/core/enums/BetStatus.js';
import './shared/core/enums/PopupTypes.js';
import { ApiVersion } from './shared/core/enums/ApiVersion.js';
import './shared/core/enums/RoundStatus.js';
import { RequestStatus } from './shared/core/enums/RequestStatus.js';
import { FreeBetsStatus } from './shared/core/enums/FreeBetsStatus.js';
import { ChatSocketEvents } from './shared/core/enums/SocketEvents.js';
import './shared/core/enums/TranslationKeys.js';
import { TimeoutMaxValue } from './shared/core/enums/TimeoutMaxValue.js';
import { ApiServiceTypes } from './shared/core/enums/ApiServiceTypes.js';
import { EnvironmentTypes } from './shared/core/enums/EnvironmentTypes.js';
import './shared/core/enums/FreeBetWinningType.js';
import { DefaultQueryParams } from './shared/core/enums/DefaultQueryParams.js';
import { BetHistoryFilterTypes } from './shared/core/enums/BetHistoryFilterTypes.js';
import { GameTheme, GameThemeNames } from './shared/core/enums/GameThemeTypes.js';
import { BetsFetchDefaultPaths, BetsFetchDefaultParamNames } from './shared/core/enums/FetchDefaultPaths.js';
import './shared/core/enums/ResponseCodes.js';
import './shared/core/store/roundInfoStore.js';
import './shared/core/store/userCountStore.js';
import { StatisticsSortingTypes } from './shared/core/enums/StatisticsSortingTypes.js';
import './shared/core/services/sound/types.js';
import './shared/core/services/sound/SoundService.js';
import './shared/core/services/sound/defaultSounds.js';
import { AuthHeaders } from './shared/core/services/api/types.js';
import { BaseApiService } from './shared/core/services/api/BaseApiService.js';
import './shared/core/store/resultHashStore.js';
import './shared/core/store/userWinBetsStore.js';
import './shared/core/store/notificationStore.js';
import { ApiServices } from './shared/core/services/ApiServices.js';
import './shared/core/store/selectedResultInfoStore.js';
import { a as getStartEndDay, m as moment } from './momentFormat-97684bf7.js';
import './table-line/t_types/enums/BetResponseCode.js';
import './table-line/t_types/enums/BetErrorMessages.js';
import './table-line/t_types/enums/NotificationByResponseCode.js';
import { FreeChipNames, FreeChipPopupActions } from './table-line/t_types/enums/FreeChipTypes.js';
import { PopUps } from './table-line/t_types/enums/PopupTypes.js';
import { parseNumberByPrecision } from './shared/core/helpers/parseNumberByPrecision.js';
import { formatDate } from './shared/core/helpers/formatDate.js';
import { findUpdateHalfData } from './shared/core/helpers/updateHalfBets.js';

var RoundsService = /** @class */ (function (_super) {
    __extends(RoundsService, _super);
    function RoundsService(config) {
        return _super.call(this, config) || this;
    }
    RoundsService.prototype.checkResultHash = function (body, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        var version = options.version;
        var url = "".concat(this.url, "/api/").concat(version, "/Rounds/checkResultHash");
        return httpClient.post(url, body);
    };
    RoundsService.prototype.getGameHighestRounds = function (options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        var version = options.version;
        var url = "".concat(this.url, "/api/").concat(version, "/Rounds/getHighestRounds");
        return httpClient.get(url);
    };
    return RoundsService;
}(BaseApiService));

var BetsService = /** @class */ (function (_super) {
    __extends(BetsService, _super);
    function BetsService(config) {
        return _super.call(this, config) || this;
    }
    BetsService.prototype.getBets = function (params, additionalPath, options) {
        if (additionalPath === void 0) { additionalPath = ''; }
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Bets").concat(additionalPath);
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    BetsService.prototype.updateFreeBetStatus = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        var version = options.version;
        var url = "".concat(this.url, "/api/").concat(version, "/FreeBets/").concat(params.freeBetId);
        return httpClient.put(url, {
            params: params,
        });
    };
    return BetsService;
}(BaseApiService));

var StatisticsService = /** @class */ (function (_super) {
    __extends(StatisticsService, _super);
    function StatisticsService(config) {
        return _super.call(this, config) || this;
    }
    StatisticsService.prototype.getStatistics = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Statistics");
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    return StatisticsService;
}(BaseApiService));

var UsersService = /** @class */ (function (_super) {
    __extends(UsersService, _super);
    function UsersService(config) {
        return _super.call(this, config) || this;
    }
    UsersService.prototype.getBalance = function (options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Users/balance");
                return [2 /*return*/, httpClient.get(url)];
            });
        });
    };
    UsersService.prototype.updateUserAvatar = function (avatarId, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Users/updateAvatar");
                return [2 /*return*/, httpClient.put(url, { avatarId: avatarId })];
            });
        });
    };
    return UsersService;
}(BaseApiService));

var FreeChipService = /** @class */ (function (_super) {
    __extends(FreeChipService, _super);
    function FreeChipService(config) {
        return _super.call(this, config) || this;
    }
    FreeChipService.prototype.sendClaimFreeBet = function (id, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/FreeBets/").concat(id);
                return [2 /*return*/, httpClient.put(url, { id: id })];
            });
        });
    };
    return FreeChipService;
}(BaseApiService));

var ChatService = /** @class */ (function () {
    function ChatService() {
        this.socket = null;
    }
    ChatService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chatConfig, _a, quickWords, typingNotAllowed, chatSocketUrl, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(!this.socket || (this.socket && this.socket.state !== HubConnectionState.Connected))) return [3 /*break*/, 7];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.getChatConfigs()];
                    case 2:
                        chatConfig = _c.sent();
                        _a = chatConfig.data.data, quickWords = _a.quickWords, typingNotAllowed = _a.typingNotAllowed;
                        chatStore.setQuickWords(quickWords);
                        chatStore.setIsTypingNotAllowed(typingNotAllowed); // typingNotAllowed - if false can type
                        if (!chatConfig) return [3 /*break*/, 4];
                        chatSocketUrl = environmentBuilder().chatSocketUrl;
                        _b = this;
                        return [4 /*yield*/, new BaseLiveConnection(chatSocketUrl).init()];
                    case 3:
                        _b.socket = _c.sent();
                        this.invokeInitialSocketEvents();
                        this.socketEventsListeners();
                        chatStore.setIsShowChat(true);
                        _c.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _c.sent();
                        if (process.env.REACT_APP_ENV !== EnvironmentTypes.Production) {
                            console.log(e_1, 'Chat service failed to connect');
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        if (this.socket && this.socket.state === HubConnectionState.Connected) {
                            this.invokeInitialSocketEvents();
                        }
                        _c.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ChatService.prototype.getChatConfiguration = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var chatHttpUrl, version, url;
            return __generator(this, function (_a) {
                chatHttpUrl = environmentBuilder().chatHttpUrl;
                version = options.version;
                url = "".concat(chatHttpUrl, "/api/").concat(version, "/Chat/Configuration");
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    ChatService.prototype.invokeInitialSocketEvents = function () {
        this.joinRoom();
        this.getChatHistory();
    };
    ChatService.prototype.socketEventsListeners = function () {
        this.socket.on(ChatSocketEvents.GetChatHistoryResult, chatStore.setChatMessageHistory);
        this.socket.on(ChatSocketEvents.ReceiveMessage, this.getMessage);
    };
    ChatService.prototype.joinRoom = function () {
        var gameTypeId = gameConfigStore.gameTypeId;
        this.socket.invoke(ChatSocketEvents.JoinRoom, +gameTypeId);
    };
    ChatService.prototype.getChatHistory = function () {
        var gameTypeId = gameConfigStore.gameTypeId;
        this.socket.invoke(ChatSocketEvents.GetChatHistory, +gameTypeId);
    };
    ChatService.prototype.leaveRoom = function () {
        if (this.socket && this.socket.state === HubConnectionState.Connected) {
            var gameTypeId = gameConfigStore.gameTypeId;
            this.socket.invoke(ChatSocketEvents.LeaveRoom, +gameTypeId);
        }
    };
    ChatService.prototype.getMessage = function (receivedMessageData) {
        if (receivedMessageData) {
            var unReadCount = chatStore.unReadCount;
            chatStore.updateChatMessageData(receivedMessageData);
            chatStore.updateUnReadCount(unReadCount + 1);
        }
    };
    ChatService.prototype.updateAdditionalData = function (gameTypeId, additionalData) {
        this.socket.invoke(ChatSocketEvents.UpdateAdditionalData, { additionalData: additionalData, gameTypeId: gameTypeId });
    };
    ChatService.prototype.sendMessage = function (data) {
        if (this.socket && this.socket.state === HubConnectionState.Connected) {
            this.socket.invoke(ChatSocketEvents.SendMessage, data);
        }
    };
    ChatService.prototype.getChatConfigs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gameId;
            return __generator(this, function (_a) {
                gameId = gameConfigStore.gameId;
                return [2 /*return*/, ApiServices.get(ApiServiceTypes.ChatService).getChatConfiguration({ gameId: gameId })];
            });
        });
    };
    ChatService.prototype.closeConnection = function () {
        if (this.socket) {
            this.socket.stop();
        }
    };
    return ChatService;
}());
var chatService = new ChatService();

var interceptorsId = null;
var httpClient = axios__default.create({
    withCredentials: true,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-type': 'application/json',
    },
});
var setHttpClientInterceptors = function () {
    if (interceptorsId || interceptorsId === 0) {
        httpClient.interceptors.request.eject(interceptorsId);
    }
    interceptorsId = httpClient.interceptors.request.use(function (config) {
        var token = applicationStore.accessToken, isAuthDataReceived = applicationStore.isAuthDataReceived;
        var accessToken = isAuthDataReceived && token ? "".concat(AuthHeaders.Bearer, " ").concat(token) : '';
        if (accessToken) {
            config.headers[AuthHeaders.Authorization] = accessToken;
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
};

var PostMessage;
(function (PostMessage) {
    PostMessage["PgReload"] = "pgReload";
    PostMessage["PgLogout"] = "pgLogout";
    PostMessage["PgGetAuthInfo"] = "pgGetAuthInfo";
    PostMessage["PgGameLoaded"] = "pgGameLoaded";
    PostMessage["PgLoginCheck"] = "pgLoginCheck";
    PostMessage["PgRedirectLogin"] = "pgRedirectLogin";
    PostMessage["PgRedirectHome"] = "pgRedirectHome";
})(PostMessage || (PostMessage = {}));
var PostMessageListenerMessages;
(function (PostMessageListenerMessages) {
    PostMessageListenerMessages["UpdateBalance"] = "updateBalance";
    PostMessageListenerMessages["StopAutoSpins"] = "stopAutospins";
    PostMessageListenerMessages["AuthInfoUpdate"] = "authInfoUpdate";
})(PostMessageListenerMessages || (PostMessageListenerMessages = {}));
var IframeService = /** @class */ (function () {
    function IframeService() {
    }
    IframeService.prototype.sendParentMessage = function (message, targetOrigin, transfer) {
        if (targetOrigin === void 0) { targetOrigin = '*'; }
        window.parent.postMessage(message, targetOrigin, transfer);
    };
    IframeService.prototype.sendTopMessage = function (message, targetOrigin, transfer) {
        if (targetOrigin === void 0) { targetOrigin = '*'; }
        window.top.postMessage(message, targetOrigin, transfer);
    };
    IframeService.prototype.openTab = function (tab) {
        this.sendTopMessage({ action: 'openSlider', tab: tab });
    };
    IframeService.prototype.openDeposit = function () {
        this.openTab('deposit');
    };
    IframeService.prototype.openLogin = function () {
        this.openTab('login');
    };
    IframeService.prototype.reloadFrame = function () {
        this.sendParentMessage(PostMessage.PgReload);
    };
    IframeService.prototype.logout = function () {
        this.sendParentMessage(PostMessage.PgLogout);
    };
    IframeService.prototype.sendLoadedState = function () {
        this.sendParentMessage(PostMessage.PgGameLoaded);
    };
    IframeService.prototype.sendGetAuthInfo = function () {
        this.sendParentMessage(PostMessage.PgGetAuthInfo);
    };
    IframeService.prototype.sendPgLogin = function () {
        this.sendParentMessage(PostMessage.PgLoginCheck);
    };
    IframeService.prototype.redirectLogin = function () {
        this.sendParentMessage(PostMessage.PgRedirectLogin);
    };
    IframeService.prototype.redirectHome = function () {
        this.sendParentMessage(PostMessage.PgRedirectHome);
    };
    IframeService.prototype.redirect = function (type) {
        if (type === void 0) { type = false; }
        type ? this.redirectHome() : this.redirectLogin();
    };
    /**
     * @deprecated please use redirect
     */
    IframeService.prototype.redirection = function (type, target) {
        console.warn('redirection method deprecated pls use redirect');
        this.redirect(type);
    };
    IframeService.prototype.isInIframe = function () {
        try {
            return window.self !== window.top;
        }
        catch (e) {
            console.error(e);
            return true;
        }
    };
    IframeService.prototype.setPostMessageListener = function (messageParams) {
        if (!this.isInIframe()) {
            applicationStore.setIsAuthDataReceived(true);
        }
        else {
            window.addEventListener('message', function (message) {
                if (message.data && message.data.name === PostMessageListenerMessages.AuthInfoUpdate) {
                    var _a = message.data, accessToken = _a.accessToken, isAuthenticated = _a.isAuthenticated;
                    applicationStore.setIsAuthenticated(isAuthenticated);
                    applicationStore.setAccessToken(accessToken);
                    applicationStore.setIsAuthDataReceived(true);
                    setHttpClientInterceptors();
                }
                if (messageParams && messageParams.length) {
                    messageParams.forEach(function (_a) {
                        var name = _a.name, callback = _a.callback;
                        if (message.data && message.data.name === name) {
                            callback(message.data);
                        }
                    });
                }
            });
        }
    };
    return IframeService;
}());
var iframeService = new IframeService();

var BaseLiveConnection = /** @class */ (function () {
    // private isOnReconnectingState: boolean = false;
    function BaseLiveConnection(url) {
        this.url = url;
    }
    BaseLiveConnection.prototype.waitStarted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.connectionStartPromise instanceof Promise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connectionStartPromise];
                    case 1:
                        _a.sent();
                        this.connectionStartPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.waitStop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.connectionStopPromise instanceof Promise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connectionStopPromise];
                    case 1:
                        _a.sent();
                        this.connectionStopPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.init = function (reconnectTimes, skipNegotiation) {
        var _a;
        if (reconnectTimes === void 0) { reconnectTimes = [300, 600]; }
        if (skipNegotiation === void 0) { skipNegotiation = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.waitStop()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.waitStarted()];
                    case 2:
                        _b.sent();
                        if (!(((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) !== HubConnectionState.Connected)) return [3 /*break*/, 4];
                        this.connection = this.createConnection(reconnectTimes, skipNegotiation);
                        this.connectionStartPromise = this.connection.start();
                        return [4 /*yield*/, this.waitStarted()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/, this.connection];
                }
            });
        });
    };
    BaseLiveConnection.prototype.createConnection = function (reconnectTimes, skipNegotiation) {
        if (reconnectTimes === void 0) { reconnectTimes = [300, 600]; }
        if (skipNegotiation === void 0) { skipNegotiation = false; }
        var accessToken = applicationStore.accessToken;
        return new HubConnectionBuilder()
            .withUrl(this.url, { accessTokenFactory: function () { return accessToken; }, skipNegotiation: skipNegotiation })
            .configureLogging(LogLevel.Information)
            .withAutomaticReconnect(reconnectTimes)
            .build();
    };
    BaseLiveConnection.prototype.invoke = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.waitStarted()];
                    case 1:
                        _b.sent();
                        if (this.connection.state === HubConnectionState.Connected)
                            return [2 /*return*/, (_a = this.connection).invoke.apply(_a, __spreadArray([methodName], __read(args), false))];
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.on = function (methodName, handler) {
        if (this.connection.state === HubConnectionState.Connected)
            this.connection.on(methodName, handler);
        return this;
    };
    BaseLiveConnection.prototype.onReconnecting = function (callback) {
        if (this.connection) {
            this.connection.onreconnecting(function (data) {
                if (callback) {
                    callback(data);
                }
                // this.isOnReconnectingState = true;
                // this.callbackMiddleware({
                //   methodName: CommonConnectionsMethod.Reconnecting,
                // });
            });
        }
    };
    BaseLiveConnection.prototype.onClose = function (callback) {
        if (this.connection && this.connection.state === HubConnectionState.Connected) {
            return this.connection.onclose(function (data) {
                if (callback) {
                    callback(data);
                }
                // if (this.isOnReconnectingState) {
                //   this.callbackMiddleware({
                //     methodName: CommonConnectionsMethod.ConnectionClose,
                //   });
                // }
            });
        }
    };
    BaseLiveConnection.prototype.onReconnected = function (callback) {
        if (this.connection) {
            return this.connection.onreconnected(function (data) {
                if (callback) {
                    callback(data);
                }
                // this.isOnReconnectingState = false;
                // this.callbackMiddleware({
                //   methodName: CommonConnectionsMethod.Reconnected,
                // });
            });
        }
    };
    BaseLiveConnection.prototype.stop = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.waitStarted()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.waitStop()];
                    case 2:
                        _b.sent();
                        if (!(((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) === HubConnectionState.Connected)) return [3 /*break*/, 4];
                        this.connectionStopPromise = this.connection.stop().then(function () {
                            _this.connectionStartPromise = null;
                        });
                        return [4 /*yield*/, this.waitStop()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.callbackMiddleware = function (_a) {
        var _b;
        var _this = this;
        var data = _a.data, methodName = _a.methodName;
        var methods = (_b = {},
            _b[CommonConnectionsMethod.UnderMaintenance] = function (arg) { return popupStore.startUnderMaintenanceFunctional(arg); },
            _b[GameLiveConnectionMethod.BalanceUpdate] = function (arg) { return userInfoStore.setBalance(arg); },
            _b[CommonConnectionsMethod.FreeBetAwarded] = function (arg) { return freeBetStore.handleAwardedFreeBets(arg); },
            _b[GameLiveConnectionMethod.FreeBetEnded] = function (arg) { return freeBetStore.handleEndedFreeBets(arg); },
            _b[GameLiveConnectionMethod.RoundStarted] = function (arg) {
                var underMaintenance = arg.underMaintenance, statistics = arg.statistics;
                if (statistics === null || statistics === void 0 ? void 0 : statistics.statistics) {
                    var buildStatisticsData = statisticsStore.buildStatisticsData, setStatistics = statisticsStore.setStatistics;
                    setStatistics(buildStatisticsData(statistics === null || statistics === void 0 ? void 0 : statistics.statistics));
                }
                (statistics === null || statistics === void 0 ? void 0 : statistics.highestOdds) && statisticsStore.setHighestOddsData(statistics === null || statistics === void 0 ? void 0 : statistics.highestOdds);
                if (underMaintenance) {
                    if (applicationStore.isBogLine) {
                        iframeService.reloadFrame();
                    }
                    else {
                        popupStore.setReloadFrameForUnderMaintenanceOnRoundStart(true);
                    }
                }
            },
            _b[GameLiveConnectionMethod.GameOpen] = function (arg) { return applicationStore.checkGameIsOpen(arg, _this.connection); },
            _b["".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.RoundFinished)] = function (arg) {
                betStore.updateCurrentWinnersWithDelay(arg.bets);
            },
            _b["".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.GetInitialStateResult)] = function (arg) {
                var currentWinners = arg.currentWinners, sliderBanners = arg.sliderBanners, hasDemo = arg.hasDemo, animationDuration = arg.animationDuration, gameTypes = arg.gameTypes, userFreebets = arg.userFreebets;
                lobbyStore.setHasDemo(hasDemo);
                lobbyStore.setGameTypes(gameTypes);
                lobbyStore.setRoundFinAnimationDuration(animationDuration);
                if (sliderBanners) {
                    lobbyStore.setSliderBanners(sliderBanners);
                }
                betStore.setCurrentWinners(currentWinners);
                freeBetStore.handleFreeBetsInitialData(userFreebets);
            },
            _b["".concat(ConnectionPrefix.Game, "_").concat(GameLiveConnectionMethod.GetInitialStateResult)] = function (arg) {
                var gameTypeId = arg.gameTypeId, avatarId = arg.avatarId, userFreebets = arg.userFreebets;
                if (applicationStore.isBogLine) {
                    profileAvatarStore.updateAvatarId(avatarId);
                    profileAvatarStore.updateInitialAvatarId(avatarId);
                }
                if (freeChipsStore.freeChipInLobby) {
                    freeChipsStore.setActiveFreeChip(freeChipsStore.freeChipInLobby);
                }
                if (!gameConfigStore.gameTypeId && gameTypeId) {
                    gameConfigStore.setGameTypeId(gameTypeId);
                }
                freeBetStore.handleFreeBetsInitialData(userFreebets, true);
            },
            _b);
        methods[methodName](data);
    };
    return BaseLiveConnection;
}());

var GameLiveConnection = /** @class */ (function (_super) {
    __extends(GameLiveConnection, _super);
    function GameLiveConnection(_a) {
        var url = _a.url;
        return _super.call(this, url) || this;
    }
    GameLiveConnection.prototype.sendGetInitialState = function (getInitialParams, additionalLiveConnectionMethod) {
        var params = __assign(__assign({}, getInitialParams), { gameId: getInitialParams.gameId || gameConfigStore.gameId });
        return this.invoke(additionalLiveConnectionMethod ? additionalLiveConnectionMethod : GameLiveConnectionMethod.GetInitialState, params);
    };
    GameLiveConnection.prototype.ping = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.connection) {
            return (_a = this.connection).invoke.apply(_a, __spreadArray([GameLiveConnectionMethod.Ping], __read(args), false));
        }
    };
    GameLiveConnection.prototype.doBet = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.connection) {
            return new Promise(function (resolve, reject) {
                var _a;
                (_a = _this.connection)
                    .invoke.apply(_a, __spreadArray([GameLiveConnectionMethod.DoBet], __read(args), false)).then(function (data) {
                    resolve(data);
                })
                    .catch(function (err) {
                    reject(err);
                    console.log('unauthorized user');
                    iframeService.sendPgLogin();
                });
            });
        }
    };
    GameLiveConnection.prototype.onGetInitialStateResult = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.GetInitialStateResult, function (data) {
            if (callback) {
                callback(data);
            }
            var gameTypeId = data.gameTypeId, avatarId = data.avatarId, userFreebets = data.userFreebets;
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Game, "_").concat(GameLiveConnectionMethod.GetInitialStateResult),
                data: { gameTypeId: gameTypeId, avatarId: avatarId, userFreebets: userFreebets },
            });
        });
    };
    GameLiveConnection.prototype.onDoBetResult = function (callback) {
        return this.on(GameLiveConnectionMethod.DoBetResult, callback);
    };
    GameLiveConnection.prototype.onFreeBetAwarded = function (callback) {
        var _this = this;
        return this.on(CommonConnectionsMethod.FreeBetAwarded, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.FreeBetAwarded,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onFreeBetEnded = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.FreeBetEnded, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.FreeBetEnded,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onDoBetResultValidation = function (callback) {
        return this.on(GameLiveConnectionMethod.DoBetResultValidation, callback);
    };
    GameLiveConnection.prototype.onRoundFinished = function (callback) {
        return this.on(GameLiveConnectionMethod.RoundFinished, callback);
    };
    GameLiveConnection.prototype.onRoundStarted = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.RoundStarted, function (data) {
            if (callback) {
                callback(data);
            }
            var _a = data.data, underMaintenance = _a.underMaintenance, statistics = _a.statistics;
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.RoundStarted,
                data: { underMaintenance: underMaintenance, statistics: statistics },
            });
        });
    };
    GameLiveConnection.prototype.onResultReport = function (callback) {
        return this.on(GameLiveConnectionMethod.ResultReport, callback);
    };
    GameLiveConnection.prototype.onMaintenanceNotify = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.MaintenanceNotify, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.UnderMaintenance,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onBalanceUpdate = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.BalanceUpdate, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.BalanceUpdate,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onPing = function (callback) {
        return this.on(GameLiveConnectionMethod.Ping, callback);
    };
    GameLiveConnection.prototype.onBetsClosed = function (callback) {
        return this.on(GameLiveConnectionMethod.BetsClosed, callback);
    };
    GameLiveConnection.prototype.onUserTournamentInfo = function (callback) {
        return this.on(GameLiveConnectionMethod.UserTournamentInfo, callback);
    };
    GameLiveConnection.prototype.onGameOpen = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.GameOpen, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.GameOpen,
                data: data,
            });
        });
    };
    return GameLiveConnection;
}(BaseLiveConnection));

var LobbyLiveConnection = /** @class */ (function (_super) {
    __extends(LobbyLiveConnection, _super);
    function LobbyLiveConnection(_a) {
        var url = _a.url;
        return _super.call(this, url) || this;
    }
    LobbyLiveConnection.prototype.sendGetInitialState = function (partnerId, gameId) {
        return this.invoke(LobbyLiveConnectionMethod.GetInitialState, {
            partnerId: partnerId,
            gameId: gameId || gameConfigStore.gameId,
        });
    };
    LobbyLiveConnection.prototype.onGetInitialStateResult = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.GetInitialStateResult, function (data) {
            if (callback) {
                callback(data);
            }
            var underMaintenance = data.underMaintenance, currentWinners = data.currentWinners, sliderBanners = data.sliderBanners, hasDemo = data.hasDemo, animationDuration = data.animationDuration, gameTypes = data.gameTypes, userFreebets = data.userFreebets;
            if (underMaintenance) {
                _this.callbackMiddleware({
                    methodName: CommonConnectionsMethod.UnderMaintenance,
                    data: underMaintenance,
                });
            }
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.GetInitialStateResult),
                data: {
                    hasDemo: hasDemo,
                    gameTypes: gameTypes,
                    userFreebets: userFreebets,
                    sliderBanners: sliderBanners,
                    currentWinners: currentWinners,
                    underMaintenance: underMaintenance,
                    animationDuration: animationDuration,
                },
            });
        });
    };
    LobbyLiveConnection.prototype.onRoundFinished = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.RoundFinished, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.RoundFinished),
                data: data,
            });
        });
    };
    LobbyLiveConnection.prototype.onFreeBetAwarded = function (callback) {
        var _this = this;
        return this.on(CommonConnectionsMethod.FreeBetAwarded, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.FreeBetAwarded,
                data: data,
            });
        });
    };
    LobbyLiveConnection.prototype.onLobbyUsersCount = function (callback) {
        return this.on(LobbyLiveConnectionMethod.LobbyUsersCount, callback);
    };
    LobbyLiveConnection.prototype.onMaintenanceNotify = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.MaintenanceNotify, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.UnderMaintenance,
                data: data,
            });
        });
    };
    return LobbyLiveConnection;
}(BaseLiveConnection));

var TranslationService = /** @class */ (function () {
    function TranslationService(_a) {
        var url = _a.url;
        this.url = url;
    }
    TranslationService.prototype.getTranslations = function (request) {
        var applicationId = request.applicationId, params = __rest(request, ["applicationId"]);
        return httpClient.get(this.url, {
            params: params,
            headers: { applicationId: applicationId },
        });
    };
    return TranslationService;
}());

var GameConfigStore = /** @class */ (function () {
    function GameConfigStore() {
        this.limits = {};
        this.gameConfiguration = {};
        this.maxAutoCashOutOdd = null;
        this._gameTypeId = null;
        this._gameId = null;
        makeObservable(this, {
            limits: observable.deep,
            _gameTypeId: observable,
            _gameId: observable,
            maxAutoCashOutOdd: observable,
            gameConfiguration: observable.deep,
            setLimits: action.bound,
            setMaxAutoCashOutOdd: action.bound,
            setGameConfiguration: action.bound,
            setGameTypeId: action.bound,
            setGameId: action.bound,
        });
    }
    GameConfigStore.prototype.setLimits = function (limits) {
        this.limits = limits;
    };
    GameConfigStore.prototype.setMaxAutoCashOutOdd = function (maxAutoCashOutOdd) {
        this.maxAutoCashOutOdd = maxAutoCashOutOdd;
    };
    GameConfigStore.prototype.setGameConfiguration = function (gameConfiguration) {
        this.gameConfiguration = gameConfiguration;
    };
    GameConfigStore.prototype.setGameTypeId = function (id) {
        this._gameTypeId = id;
    };
    Object.defineProperty(GameConfigStore.prototype, "gameTypeId", {
        get: function () {
            return this._gameTypeId || parseQuery(window.location.search)[DefaultQueryParams.GameTypeId];
        },
        enumerable: false,
        configurable: true
    });
    GameConfigStore.prototype.setGameId = function (id) {
        this._gameId = id;
    };
    Object.defineProperty(GameConfigStore.prototype, "gameId", {
        get: function () {
            return this._gameId || parseQuery(window.location.search)[DefaultQueryParams.GameId];
        },
        enumerable: false,
        configurable: true
    });
    return GameConfigStore;
}());
var gameConfigStore = new GameConfigStore();

var StatisticsStore = /** @class */ (function () {
    function StatisticsStore() {
        this.statistics = {
            100: [],
            200: [],
            500: [],
        };
        this.highestOddsData = [];
        makeObservable(this, {
            statistics: observable.deep,
            highestOddsData: observable.deep,
            setStatistics: action.bound,
            setHighestOddsData: action.bound,
            getHttpStatistics: flow.bound,
            sortStatisticsDataBySortType: action.bound,
        });
    }
    StatisticsStore.prototype.buildStatisticsData = function (statistics) {
        var currentStatisticsData = {};
        var convertObjToArray = function (obj) { var _a; return (_a = Object.keys(obj)) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, curr) { return __spreadArray(__spreadArray([], __read(acc), false), [{ num: curr, count: obj[curr] }], false); }, []); };
        for (var key in statistics) {
            currentStatisticsData[key] = convertObjToArray(statistics[key]);
        }
        return currentStatisticsData;
    };
    StatisticsStore.prototype.setHighestOddsData = function (highestOddsData) {
        this.highestOddsData = highestOddsData;
    };
    StatisticsStore.prototype.getHttpStatistics = function () {
        var gameTypeId, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    gameTypeId = gameConfigStore.gameTypeId;
                    return [4 /*yield*/, ApiServices.get(ApiServiceTypes.StatisticsService).getStatistics({ gameTypeId: gameTypeId })];
                case 1:
                    result = (_a.sent()).data.result;
                    (result === null || result === void 0 ? void 0 : result.statistics) && this.setStatistics(this.buildStatisticsData(result === null || result === void 0 ? void 0 : result.statistics));
                    (result === null || result === void 0 ? void 0 : result.highestOdds) && this.setHighestOddsData(result === null || result === void 0 ? void 0 : result.highestOdds);
                    return [2 /*return*/];
            }
        });
    };
    StatisticsStore.prototype.setStatistics = function (statistics) {
        this.statistics = statistics;
    };
    StatisticsStore.prototype.sortStatisticsDataBySortType = function (sortType, lastRoundValue) {
        var _a, _b, _c;
        var Default = StatisticsSortingTypes.Default, Ascending = StatisticsSortingTypes.Ascending, Descending = StatisticsSortingTypes.Descending;
        var sortDataByType = (_a = {},
            _a[Default] = this.statistics,
            _a[Ascending] = __assign(__assign({}, this.statistics), (_b = {}, _b[lastRoundValue] = this.statistics[lastRoundValue].slice().sort(function (a, b) { return a.count - b.count; }), _b)),
            _a[Descending] = __assign(__assign({}, this.statistics), (_c = {}, _c[lastRoundValue] = this.statistics[lastRoundValue].slice().sort(function (a, b) { return b.count - a.count; }), _c)),
            _a);
        return __assign({}, sortDataByType[sortType]);
    };
    return StatisticsStore;
}());
var statisticsStore = new StatisticsStore();

var PopupStore = /** @class */ (function () {
    function PopupStore() {
        this.popupName = null;
        this.popupToggle = false;
        this.currentData = null;
        this.underMaintenance = false;
        this.maxWinToastState = false;
        this.reloadFrameForUnderMaintenanceOnCountDown = false;
        this.reloadFrameForUnderMaintenanceOnRoundStart = false;
        this.underMaintenanceSeconds = null;
        this.reconnect = false;
        this.connectionError = false;
        this.slowConnection = false;
        this.isFromBetHistory = false;
        this.isFromHighestRounds = false;
        this.hashResult = null;
        this.demoBetsCount = 0;
        // for mobile lobby page condition, game types or topWinners
        this.isGameTypesSectionActive = true;
        makeObservable(this, {
            popupName: observable,
            popupToggle: observable,
            currentData: observable,
            underMaintenance: observable,
            maxWinToastState: observable,
            reloadFrameForUnderMaintenanceOnCountDown: observable,
            reloadFrameForUnderMaintenanceOnRoundStart: observable,
            underMaintenanceSeconds: observable,
            reconnect: observable,
            connectionError: observable,
            slowConnection: observable,
            isFromBetHistory: observable,
            hashResult: observable,
            isGameTypesSectionActive: observable,
            demoBetsCount: observable,
            open: action.bound,
            close: action.bound,
            detectAndOpenCheckHashPopup: action.bound,
            onUnderMaintenanceCountdown: action.bound,
            toggleUnderMaintenance: action.bound,
            toggleReconnect: action.bound,
            onConnectionError: action.bound,
            toggleSlowConnection: action.bound,
            setReloadFrameForUnderMaintenanceOnCountDown: action.bound,
            setReloadFrameForUnderMaintenanceOnRoundStart: action.bound,
            maxWinToggle: action.bound,
            setHashResult: action.bound,
            getHashResult: action.bound,
            setIsGameTypesSectionActive: action.bound,
            setDemoBetsCount: action.bound,
            updateDemoBetsCount: action.bound,
        });
    }
    PopupStore.prototype.setDemoBetsCount = function (count) {
        this.demoBetsCount = count;
    };
    PopupStore.prototype.updateDemoBetsCount = function () {
        this.demoBetsCount += 1;
    };
    PopupStore.prototype.open = function (_a) {
        var _b = _a.data, data = _b === void 0 ? null : _b, _c = _a.name, name = _c === void 0 ? null : _c, _d = _a.isFromBetHistory, isFromBetHistory = _d === void 0 ? false : _d, _e = _a.isFromHighestRounds, isFromHighestRounds = _e === void 0 ? false : _e;
        this.popupToggle = true;
        this.currentData = data;
        this.popupName = name;
        this.isFromBetHistory = isFromBetHistory;
        this.isFromHighestRounds = isFromHighestRounds;
    };
    PopupStore.prototype.close = function (e) {
        if (e === void 0) { e = null; }
        e && e.stopPropagation();
        this.popupToggle = false;
        this.currentData = null;
        this.popupName = null;
    };
    PopupStore.prototype.startUnderMaintenanceFunctional = function (_a) {
        var _this = this;
        var startDate = _a.startDate, notifySeconds = _a.notifySeconds;
        if (startDate) {
            var seconds_1 = Math.floor((+new Date("".concat(startDate).concat(startDate.includes('Z') ? '' : 'Z')) - +new Date()) / 1000);
            if (!notifySeconds || (notifySeconds > seconds_1 && seconds_1 >= 0)) {
                this.toggleUnderMaintenance(true);
                this.onUnderMaintenanceCountdown(seconds_1);
            }
            var interval_1 = setInterval(function () {
                if (seconds_1 >= 0) {
                    if (notifySeconds === seconds_1) {
                        _this.toggleUnderMaintenance(true);
                    }
                    if (!notifySeconds || notifySeconds >= seconds_1) {
                        _this.onUnderMaintenanceCountdown(seconds_1);
                    }
                    seconds_1 -= 1;
                }
                else {
                    clearInterval(interval_1);
                    _this.setReloadFrameForUnderMaintenanceOnCountDown(true);
                }
            }, 1000);
        }
    };
    PopupStore.prototype.onUnderMaintenanceCountdown = function (seconds) {
        this.underMaintenanceSeconds = seconds;
    };
    PopupStore.prototype.toggleUnderMaintenance = function (state) {
        if (state !== undefined) {
            this.underMaintenance = state;
        }
        else {
            this.underMaintenance = !this.underMaintenance;
        }
    };
    PopupStore.prototype.toggleReconnect = function (state) {
        if (state !== undefined) {
            this.reconnect = state;
        }
        else {
            this.reconnect = !this.reconnect;
        }
    };
    PopupStore.prototype.onConnectionError = function (state) {
        this.connectionError = state;
    };
    PopupStore.prototype.toggleSlowConnection = function (state) {
        if (state !== undefined) {
            this.slowConnection = state;
        }
        else {
            this.slowConnection = !this.slowConnection;
        }
    };
    PopupStore.prototype.setReloadFrameForUnderMaintenanceOnCountDown = function (state) {
        if (state !== undefined) {
            this.reloadFrameForUnderMaintenanceOnCountDown = state;
        }
        else {
            this.reloadFrameForUnderMaintenanceOnCountDown = !this.reloadFrameForUnderMaintenanceOnCountDown;
        }
    };
    PopupStore.prototype.setReloadFrameForUnderMaintenanceOnRoundStart = function (state) {
        if (state !== undefined) {
            this.reloadFrameForUnderMaintenanceOnRoundStart = state;
        }
        else {
            this.reloadFrameForUnderMaintenanceOnRoundStart = !this.reloadFrameForUnderMaintenanceOnRoundStart;
        }
    };
    PopupStore.prototype.maxWinToggle = function (state) {
        if (state !== undefined) {
            this.maxWinToastState = state;
        }
        else {
            this.maxWinToastState = !this.maxWinToastState;
        }
    };
    PopupStore.prototype.detectAndOpenCheckHashPopup = function (_a) {
        var selectedId = _a.selectedId, name = _a.name, _b = _a.isFromBetHistory, isFromBetHistory = _b === void 0 ? false : _b, _c = _a.isFromHighestRounds, isFromHighestRounds = _c === void 0 ? false : _c;
        var data;
        if (isFromBetHistory) {
            var betHistoryData = betStore.betHistory.data;
            data = betHistoryData.find(function (_a) {
                var id = _a.id;
                return id === selectedId;
            });
        }
        else {
            var gameResults = gameResultStore.gameResults;
            var highestOddsData = statisticsStore.highestOddsData;
            data = (isFromHighestRounds ? highestOddsData : gameResults).find(function (_a) {
                var roundId = _a.roundId;
                return roundId === selectedId;
            });
            if (isFromHighestRounds) {
                data = data.roundData;
            }
        }
        this.open({ data: data, name: name, isFromBetHistory: isFromBetHistory, isFromHighestRounds: isFromHighestRounds });
    };
    PopupStore.prototype.getHashResult = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchedData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiServices.get(ApiServiceTypes.RoundsService).checkResultHash(data)];
                    case 1:
                        fetchedData = _a.sent();
                        if (fetchedData && fetchedData.data.result) {
                            this.setHashResult(fetchedData.data.result);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PopupStore.prototype.setHashResult = function (hashResult) {
        if (hashResult === void 0) { hashResult = null; }
        this.hashResult = hashResult;
    };
    PopupStore.prototype.setIsGameTypesSectionActive = function (state) {
        if (state !== undefined) {
            this.isGameTypesSectionActive = state;
        }
        else {
            this.isGameTypesSectionActive = !this.isGameTypesSectionActive;
        }
    };
    return PopupStore;
}());
var popupStore = new PopupStore();

var ProfileAvatarStore = /** @class */ (function () {
    function ProfileAvatarStore() {
        this.isMobileAvatarsBlockOpened = false;
        this.availableAvatarsType = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
        this.avatarId = this.availableAvatarsType[0];
        this.initialAvatarId = null;
        makeObservable(this, {
            avatarId: observable,
            initialAvatarId: observable,
            updateInitialAvatarId: action.bound,
            isMobileAvatarsBlockOpened: observable,
            updateAvatarId: action.bound,
            sendAvatarIdToBackend: action.bound,
        });
    }
    ProfileAvatarStore.prototype.updateAvatarId = function (id) {
        this.avatarId = id;
    };
    ProfileAvatarStore.prototype.updateInitialAvatarId = function (initialAvatarId) {
        this.initialAvatarId = initialAvatarId;
    };
    ProfileAvatarStore.prototype.sendAvatarIdToBackend = function (userId) {
        var _this = this;
        var gameTypeId = gameConfigStore.gameTypeId;
        ApiServices.get(ApiServiceTypes.UsersService)
            .updateUserAvatar(this.avatarId)
            .then(function () {
            if (chatStore.isShowChat) {
                var chatMessageData = chatStore.chatMessageData;
                var updatedChatMessageData = chatMessageData === null || chatMessageData === void 0 ? void 0 : chatMessageData.map(function (item) {
                    if ((item === null || item === void 0 ? void 0 : item.userId) === userId) {
                        return __assign(__assign({}, item), { avatarId: _this.avatarId });
                    }
                    return item;
                });
                chatService.updateAdditionalData(+gameTypeId, _this.avatarId);
                chatStore.setChatMessageHistory(updatedChatMessageData);
            }
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    return ProfileAvatarStore;
}());
var profileAvatarStore = new ProfileAvatarStore();

var ApplicationStore = /** @class */ (function () {
    function ApplicationStore() {
        this.isDemo = false;
        this.accessToken = '';
        this.isGuest = false;
        this.isBogLine = false;
        this.gameIsOpen = false;
        this.isTestPlatform = false;
        this.isISOStandard = false;
        this.isAuthenticated = false;
        this.isAuthDataReceived = false;
        this.alreadyRedirectedToGame = false;
        makeObservable(this, {
            isDemo: observable,
            isGuest: observable,
            gameIsOpen: observable,
            isTestPlatform: observable,
            isISOStandard: observable,
            accessToken: observable,
            isAuthenticated: observable,
            isAuthDataReceived: observable,
            isBogLine: observable,
            setIsDemo: action.bound,
            setIsGuest: action.bound,
            setGameIsOpen: action.bound,
            checkGameIsOpen: action.bound,
            setIsTestPlatform: action.bound,
            setIsISOStandard: action.bound,
            setAccessToken: action.bound,
            setIsAuthenticated: action.bound,
            setIsAuthDataReceived: action.bound,
            setIsBogLine: action.bound,
            setAlreadyRedirectedToGame: action.bound,
        });
    }
    ApplicationStore.prototype.setIsDemo = function (isDemo) {
        this.isDemo = isDemo;
    };
    ApplicationStore.prototype.setGameIsOpen = function (gameIsOpen) {
        this.gameIsOpen = gameIsOpen;
    };
    ApplicationStore.prototype.setIsTestPlatform = function (isTestPlatform) {
        this.isTestPlatform = isTestPlatform;
    };
    ApplicationStore.prototype.checkGameIsOpen = function (data, connection) {
        var gameTypeId = gameConfigStore.gameTypeId, gameId = gameConfigStore.gameId;
        if (connection &&
            connection.connectionId !== data.connectionId &&
            (data.gameId === +gameId || data.gameTypeId === +gameTypeId)) {
            this.setGameIsOpen(true);
            if (!this.isBogLine) {
                popupStore.open({ name: PopUps.GameOpen });
            }
            connection.stop();
        }
    };
    ApplicationStore.prototype.setIsGuest = function (isGuest) {
        this.isGuest = isGuest;
    };
    ApplicationStore.prototype.setIsISOStandard = function (isISOStandard) {
        this.isISOStandard = isISOStandard;
    };
    ApplicationStore.prototype.demoSwitcher = function (demoSwitcherAdditionalFunction) {
        var isAuthenticated = applicationStore.isAuthenticated, isBogLine = applicationStore.isBogLine;
        isBogLine && profileAvatarStore.updateAvatarId(profileAvatarStore.initialAvatarId);
        if (isAuthenticated) {
            applicationStore.setIsDemo(false);
            if (popupStore.demoBetsCount) {
                popupStore.setDemoBetsCount(0);
            }
            if (demoSwitcherAdditionalFunction) {
                demoSwitcherAdditionalFunction();
            }
        }
        else {
            iframeService.sendPgLogin();
        }
    };
    ApplicationStore.prototype.setAccessToken = function (accessToken) {
        this.accessToken = accessToken;
    };
    ApplicationStore.prototype.setIsAuthenticated = function (isAuthenticated) {
        this.isAuthenticated = isAuthenticated;
    };
    ApplicationStore.prototype.setIsAuthDataReceived = function (isAuthDataReceived) {
        this.isAuthDataReceived = isAuthDataReceived;
    };
    ApplicationStore.prototype.setIsBogLine = function (isBogLine) {
        this.isBogLine = isBogLine;
    };
    ApplicationStore.prototype.setAlreadyRedirectedToGame = function (value) {
        this.alreadyRedirectedToGame = value;
    };
    return ApplicationStore;
}());
var applicationStore = new ApplicationStore();

var bannerImageTypeList = ['jpg', 'png', 'gif', 'svg'];
var gameTypeIntervalIds = {};
var gameTypeTimeByIds = {};
var LobbyStore = /** @class */ (function () {
    function LobbyStore() {
        this.gameTypes = [];
        this.hasDemo = true;
        this.roomName = '';
        this.lobbyDurationsByGameTypeId = {};
        this.sliderBanners = [];
        this.roundFinAnimationDuration = 0;
        makeObservable(this, {
            roundFinAnimationDuration: observable,
            lobbyDurationsByGameTypeId: observable.deep,
            roomName: observable.deep,
            gameTypes: observable.deep,
            hasDemo: observable.deep,
            sliderBanners: observable.deep,
            setGameTypes: action.bound,
            setHasDemo: action.bound,
            setRoomName: action.bound,
            setSliderBanners: action.bound,
            setRoundFinAnimationDuration: action.bound,
            setLobbyDurationsByGameTypeId: action.bound,
            setRoundTimeByGameTypes: action.bound,
        });
    }
    LobbyStore.prototype.setLobbyDurationsByGameTypeId = function (arg) {
        this.lobbyDurationsByGameTypeId = arg;
    };
    LobbyStore.prototype.setGameTypes = function (gameTypes) {
        this.gameTypes = gameTypes;
    };
    LobbyStore.prototype.setHasDemo = function (hasDemo) {
        this.hasDemo = hasDemo;
    };
    LobbyStore.prototype.setRoomName = function (name) {
        this.roomName = name;
    };
    LobbyStore.prototype.setRoundFinAnimationDuration = function (animationDuration) {
        this.roundFinAnimationDuration = animationDuration ? animationDuration * 1000 : this.roundFinAnimationDuration;
    };
    LobbyStore.prototype.setSliderBanners = function (banners) {
        var httpBannersUrl = environmentBuilder().httpBannersUrl;
        this.sliderBanners = banners
            .sort(function (a, b) { return a.priority - b.priority; })
            .map(function (banner, index) {
            var _a;
            var bannerType = (_a = banner === null || banner === void 0 ? void 0 : banner.url) === null || _a === void 0 ? void 0 : _a.split('.').pop();
            var isVideo = banner.isVideo || !bannerImageTypeList.includes(bannerType);
            return __assign(__assign({}, banner), { url: "".concat(httpBannersUrl, "/").concat(banner.url), id: index + 1, isVideo: isVideo, isActive: !index, isPrev: false });
        });
    };
    LobbyStore.prototype.setRoundTimeByGameTypes = function (gameTypeId, time) {
        var _this = this;
        if (gameTypeIntervalIds[gameTypeId]) {
            clearInterval(gameTypeIntervalIds[gameTypeId]);
            gameTypeIntervalIds[gameTypeId] = null;
        }
        gameTypeTimeByIds[gameTypeId] = Math.floor(time) <= 0 ? 0 : Math.floor(time);
        this.setLobbyDurationsByGameTypeId(__assign(__assign({}, this.lobbyDurationsByGameTypeId), { gameTypeId: gameTypeTimeByIds[gameTypeId] }));
        gameTypeIntervalIds[gameTypeId] = setInterval(function () {
            var _a;
            gameTypeTimeByIds[gameTypeId] = gameTypeTimeByIds[gameTypeId] - 1 <= 0 ? 0 : gameTypeTimeByIds[gameTypeId] - 1;
            _this.setLobbyDurationsByGameTypeId(__assign(__assign({}, _this.lobbyDurationsByGameTypeId), (_a = {}, _a[gameTypeId] = gameTypeTimeByIds[gameTypeId], _a)));
            if (gameTypeTimeByIds[gameTypeId] === 0) {
                clearInterval(gameTypeIntervalIds[gameTypeId]);
                gameTypeIntervalIds[gameTypeId] = null;
            }
        }, 1000);
    };
    return LobbyStore;
}());
var lobbyStore = new LobbyStore();

var BetsStore = /** @class */ (function () {
    function BetsStore() {
        this.liveBets = []; // GAME BETS
        this.currentWinners = []; // LOBBY BETS
        this._betHistory = new HttpResponse([]);
        this._demoBetHistory = [];
        this.betHistoryTotalCount = 0;
        this.topWinners = new HttpResponse([]);
        this.topWinnersTotalCount = 0;
        this.betHistoryFilter = BetHistoryFilterTypes.All;
        this.topWinnersDefaultTake = 20;
        this.betsDefaultTake = 20;
        this.currentWinnersTimeOutId = null;
        this.maxCurrentWinnersCount = 50;
        makeObservable(this, {
            betHistory: computed,
            topWinners: observable.deep,
            _betHistory: observable.deep,
            _demoBetHistory: observable.deep,
            betHistoryFilter: observable,
            currentWinners: observable,
            betsService: computed,
            liveBets: observable.deep,
            setTopWinners: action.bound,
            setDemoBetHistory: action.bound,
            updateDemoBetHistory: action.bound,
            setBetHistory: action.bound,
            setBetHistoryFilter: action.bound,
            setCurrentWinners: action.bound,
            updateCurrentWinners: action.bound,
            resetBetHistory: action.bound,
            resetTopWinners: action.bound,
            setLiveBets: action.bound,
            updateLiveBets: action.bound,
            spliceLiveBets: action.bound,
            getTopWinners: flow.bound,
            getBetHistory: flow.bound,
        });
    }
    Object.defineProperty(BetsStore.prototype, "betsService", {
        get: function () {
            return ApiServices.get(ApiServiceTypes.BetsService);
        },
        enumerable: false,
        configurable: true
    });
    BetsStore.prototype.getTopWinners = function (params) {
        var _a, skip, _b, take, _c, fetchPath;
        var _this = this;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_d) {
            _a = params.skip, skip = _a === void 0 ? this.topWinners.data.length : _a, _b = params.take, take = _b === void 0 ? this.topWinnersDefaultTake : _b, _c = params.fetchPath, fetchPath = _c === void 0 ? BetsFetchDefaultPaths.TopWinners : _c;
            if (!this.topWinnersTotalCount ||
                !this.topWinners.data.length ||
                (this.topWinners.data.length + 1 < this.topWinnersTotalCount && this.topWinners.status !== RequestStatus.Pending)) {
                this.fetchingTopWinners();
                this.betsService
                    .getBets({ skip: skip, take: take }, fetchPath)
                    .then(function (_a) {
                    var _b = _a.data.result, items = _b.items, count = _b.count;
                    _this.topWinnersTotalCount = count;
                    _this.fetchedTopWinners(items);
                })
                    .catch(function (error) {
                    _this.setTopWinners(_this.topWinners.failed(error));
                });
            }
            return [2 /*return*/];
        });
    };
    BetsStore.prototype.setTopWinners = function (topWinners) {
        this.topWinners = topWinners;
    };
    BetsStore.prototype.getBetHistory = function (params, customStatus, customBetHistoryParser) {
        var _a, skip, _b, take;
        var _this = this;
        if (params === void 0) { params = {}; }
        if (customBetHistoryParser === void 0) { customBetHistoryParser = function (data) { return data; }; }
        return __generator(this, function (_c) {
            _a = params.skip, skip = _a === void 0 ? this._betHistory.data.length : _a, _b = params.take, take = _b === void 0 ? this.betsDefaultTake : _b;
            if (!this.betHistoryTotalCount ||
                !this._betHistory.data.length ||
                (this._betHistory.data.length + 1 < this.betHistoryTotalCount &&
                    this._betHistory.status !== RequestStatus.Pending)) {
                this.fetchingBetHistory();
                this.betsService
                    .getBets({
                    skip: skip,
                    take: take,
                    status: customStatus !== undefined
                        ? customStatus
                        : this.betHistoryFilter === BetHistoryFilterTypes.All
                            ? null
                            : this.betHistoryFilter,
                })
                    .then(function (_a) {
                    var _b = _a.data.result, items = _b.items, count = _b.count;
                    _this.betHistoryTotalCount = count;
                    _this.fetchedBetHistory(items, customBetHistoryParser, customStatus);
                })
                    .catch(function (error) {
                    _this.setBetHistory(_this._betHistory.failed(error));
                });
            }
            return [2 /*return*/];
        });
    };
    BetsStore.prototype.setBetHistory = function (bets) {
        this._betHistory = bets;
    };
    BetsStore.prototype.setDemoBetHistory = function (bets) {
        this._demoBetHistory = bets;
    };
    BetsStore.prototype.updateDemoBetHistory = function (bets) {
        this._demoBetHistory = __spreadArray(__spreadArray([], __read(bets), false), __read(this._demoBetHistory), false);
    };
    BetsStore.prototype.setCurrentWinners = function (currentWinners) {
        if (this.currentWinnersTimeOutId) {
            clearTimeout(this.currentWinnersTimeOutId);
        }
        findUpdateHalfData(currentWinners);
        this.currentWinners = currentWinners;
    };
    BetsStore.prototype.updateCurrentWinnersWithDelay = function (currentWinners) {
        var _this = this;
        if (currentWinners.length) {
            findUpdateHalfData(currentWinners);
            this.currentWinnersTimeOutId = setTimeout(function () {
                _this.updateCurrentWinners(currentWinners);
            }, lobbyStore.roundFinAnimationDuration);
        }
    };
    BetsStore.prototype.updateCurrentWinners = function (currentWinners) {
        var currentWinnersResult = __spreadArray(__spreadArray([], __read(currentWinners), false), __read(this.currentWinners), false);
        if (currentWinnersResult.length > this.maxCurrentWinnersCount) {
            currentWinnersResult.splice(this.maxCurrentWinnersCount);
        }
        this.currentWinners = currentWinnersResult;
    };
    BetsStore.prototype.setLiveBets = function (liveBets) {
        this.liveBets = liveBets;
    };
    BetsStore.prototype.updateLiveBets = function (liveBet) {
        if (Array.isArray(liveBet)) {
            this.liveBets = __spreadArray(__spreadArray([], __read(this.liveBets), false), __read(liveBet), false);
        }
        else {
            this.liveBets = __spreadArray(__spreadArray([], __read(this.liveBets), false), [liveBet], false);
        }
    };
    BetsStore.prototype.spliceLiveBets = function (from, to) {
        this.liveBets.splice(from, to);
    };
    BetsStore.prototype.setBetHistoryFilter = function (filter, customStatus, customBetHistoryParser) {
        this.betHistoryFilter = filter;
        if (!applicationStore.isDemo) {
            this.resetBetHistory();
            this.getBetHistory({}, customStatus, customBetHistoryParser);
        }
    };
    BetsStore.prototype.fetchingBetHistory = function () {
        this.setBetHistory(this._betHistory.fetching());
    };
    BetsStore.prototype.fetchedBetHistory = function (response, customBetHistoryParser, customStatus) {
        if (customStatus === null) {
            this.setBetHistory(this._betHistory.fetched(customBetHistoryParser(__spreadArray(__spreadArray([], __read(this._betHistory.data), false), __read(response), false))));
        }
        else {
            this.setBetHistory(this._betHistory.fetched(__spreadArray(__spreadArray([], __read(this._betHistory.data), false), __read(customBetHistoryParser(response)), false)));
        }
    };
    BetsStore.prototype.fetchingTopWinners = function () {
        this.setTopWinners(this.topWinners.fetching());
    };
    BetsStore.prototype.fetchedTopWinners = function (response) {
        var _a, _b;
        findUpdateHalfData(response, true);
        var result = __spreadArray(__spreadArray([], __read(this.topWinners.data), false), __read(response), false);
        var isHalfCashOut = (_b = (_a = result[0]) === null || _a === void 0 ? void 0 : _a.additionalParams) === null || _b === void 0 ? void 0 : _b.cashOutInfos;
        if (isHalfCashOut) {
            result.sort(function (a, b) { return b.winAmount - a.winAmount; });
        }
        this.setTopWinners(this.topWinners.fetched(result));
    };
    BetsStore.prototype.resetTopWinners = function () {
        this.setTopWinners(this.topWinners.fetching(true));
    };
    BetsStore.prototype.resetBetHistory = function () {
        this.setBetHistory(this._betHistory.fetching(true));
    };
    Object.defineProperty(BetsStore.prototype, "betHistory", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            // need to improve
            return isDemo ? { data: this._demoBetHistory } : this._betHistory;
        },
        enumerable: false,
        configurable: true
    });
    return BetsStore;
}());
var betStore = new BetsStore();

var UserInfoStore = /** @class */ (function () {
    function UserInfoStore() {
        this.rate = '';
        this.precision = '';
        this.playerExternalId = '';
        this.userId = '';
        this._currencyCode = '';
        this._demoCurrencyCode = 'Fun';
        this._currencySymbol = '';
        this._balance = 0;
        this._demoInitialBalance = 500000;
        this._demoBalance = this._demoInitialBalance;
        makeObservable(this, {
            rate: observable,
            precision: observable,
            currencyCode: computed,
            currencySymbolOrCode: computed,
            realCurrencySymbolOrCode: computed,
            realCurrencyCode: computed,
            balance: computed,
            playerExternalId: observable,
            userId: observable,
            _demoBalance: observable,
            _balance: observable,
            _demoCurrencyCode: observable,
            _currencyCode: observable,
            usersService: computed,
            setRate: action.bound,
            setUserId: action.bound,
            setBalance: action.bound,
            setUserInfo: action.bound,
            setPrecision: action.bound,
            getUserBalance: flow.bound,
            setDemoBalance: action.bound,
            setCurrencyCode: action.bound,
            setCurrencySymbol: action.bound,
            setPlayerExternalId: action.bound,
            setDemoInitialBalance: action.bound,
        });
    }
    UserInfoStore.prototype.setUserInfo = function (userInfo) {
        var rate = userInfo.rate, precision = userInfo.precision, currencyCode = userInfo.currencyCode, currencySymbol = userInfo.currencySymbol, balance = userInfo.balance, playerExternalId = userInfo.playerExternalId, demoBalance = userInfo.demoBalance, userId = userInfo.userId;
        this.setRate(rate);
        this.setPrecision(precision);
        this.setCurrencyCode(currencyCode);
        this.setCurrencySymbol(currencySymbol);
        this.setBalance(balance);
        this.setPlayerExternalId(playerExternalId);
        this.setUserId(userId);
        if (demoBalance) {
            this.setDemoBalance(demoBalance);
        }
    };
    UserInfoStore.prototype.setRate = function (rate) {
        this.rate = rate;
    };
    UserInfoStore.prototype.setUserId = function (userId) {
        if (userId) {
            this.userId = userId;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.UserId, userIdFromQuery = _a[_b];
            this.userId = userIdFromQuery;
        }
    };
    UserInfoStore.prototype.setPrecision = function (precision) {
        this.precision = precision;
    };
    UserInfoStore.prototype.setCurrencyCode = function (currencyCode) {
        this._currencyCode = currencyCode;
    };
    UserInfoStore.prototype.setCurrencySymbol = function (currencySymbol) {
        if (currencySymbol) {
            this._currencySymbol = currencySymbol;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.CurrencySymbol, currencySymbolFromQuery = _a[_b];
            this._currencySymbol = currencySymbolFromQuery;
        }
    };
    UserInfoStore.prototype.setBalance = function (balance) {
        this._balance = balance;
    };
    UserInfoStore.prototype.setPlayerExternalId = function (playerExternalId) {
        if (playerExternalId) {
            this.playerExternalId = playerExternalId;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.PlayerExternalId, playerExternalIdFromQuery = _a[_b];
            this.playerExternalId = playerExternalIdFromQuery;
        }
    };
    UserInfoStore.prototype.setDemoInitialBalance = function () {
        this._demoBalance = this._demoInitialBalance;
    };
    UserInfoStore.prototype.setDemoBalance = function (demoBalance) {
        this._demoBalance = parseNumberByPrecision(demoBalance, 1);
    };
    UserInfoStore.prototype.getUserBalance = function () {
        var isAuthenticated, isDemo, result, balance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isAuthenticated = applicationStore.isAuthenticated, isDemo = applicationStore.isDemo;
                    if (!(isAuthenticated && !isDemo)) return [3 /*break*/, 6];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (!this.usersService) return [3 /*break*/, 3];
                    return [4 /*yield*/, this.usersService.getBalance()];
                case 2:
                    result = (_a.sent()).data.result;
                    if (result) {
                        balance = result.balance;
                        this.setBalance(balance);
                    }
                    else {
                        iframeService.sendPgLogin();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    console.error('please integrate users service');
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    _a.sent();
                    iframeService.sendPgLogin();
                    console.error('get balance error');
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    };
    Object.defineProperty(UserInfoStore.prototype, "usersService", {
        get: function () {
            return ApiServices.get(ApiServiceTypes.UsersService);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "balance", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            return isDemo ? this._demoBalance : this._balance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "currencyCode", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            return isDemo ? this._demoCurrencyCode : this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "currencySymbolOrCode", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            return isDemo ? this._demoCurrencyCode : this._currencySymbol || this.currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "realCurrencySymbolOrCode", {
        get: function () {
            return this._currencySymbol || this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "realCurrencyCode", {
        get: function () {
            return this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    return UserInfoStore;
}());
var userInfoStore = new UserInfoStore();

var FreeBetStore = /** @class */ (function () {
    function FreeBetStore() {
        this.freeBets = [];
        this.activeFreeBet = {};
        this.endedFreeBets = [];
        this.freeBetEnded = null;
        this.awardedFreeBet = null;
        this.expireDayCount = null;
        this.firstExpireFreeBetTimeOutId = null;
        this.firstExpireFreeBetsData = [];
        makeObservable(this, {
            freeBetEnded: observable,
            awardedFreeBet: observable,
            expireDayCount: observable,
            freeBets: observable.deep,
            activeFreeBet: observable.deep,
            endedFreeBets: observable.deep,
            firstExpireFreeBetTimeOutId: observable,
            firstExpireFreeBetsData: observable.deep,
            unUseFreeBetCount: computed,
            setFreeBets: action.bound,
            selectFreeBet: action.bound,
            handleUseLater: action.bound,
            updatedFreeBets: action.bound,
            setFreeBetEnded: action.bound,
            setEndedFreeBets: action.bound,
            createExpireDate: action.bound,
            setAwardedFreeBet: action.bound,
            setExpireDayCount: action.bound,
            setActivateFreeBet: action.bound,
            resetActiveFreeBet: action.bound,
            handleEndedFreeBets: action.bound,
            handleExpireFreeBets: action.bound,
            selectFreeBetInStatus: action.bound,
            handleAwardedFreeBets: action.bound,
            freeBetsSortFunctional: action.bound,
            handleFreeBetDoBetResult: action.bound,
            checkFirstExpireFreeBets: action.bound,
            handleFreeBetsInitialData: action.bound,
            freeBetTotalWinCalculator: action.bound,
            changeExpireFreeBetsStatus: action.bound,
            setFirstExpireFreeBetsData: action.bound,
            resetOldAndGenerateNewExpireData: action.bound,
            freeBetsStatusChanger: flow.bound,
        });
    }
    FreeBetStore.prototype.setFreeBets = function (freeBetsList) {
        this.freeBets = freeBetsList;
    };
    FreeBetStore.prototype.updatedFreeBets = function (freeBet) {
        this.freeBets = __spreadArray(__spreadArray([], __read(freeBet), false), __read(this.freeBets), false);
    };
    FreeBetStore.prototype.setActivateFreeBet = function (freeBet) {
        this.activeFreeBet = freeBet;
    };
    FreeBetStore.prototype.setFreeBetEnded = function (freeBet) {
        this.freeBetEnded = freeBet;
    };
    FreeBetStore.prototype.setAwardedFreeBet = function (freeBet) {
        this.awardedFreeBet = freeBet;
    };
    FreeBetStore.prototype.resetActiveFreeBet = function () {
        this.activeFreeBet = {};
    };
    FreeBetStore.prototype.setEndedFreeBets = function (freeBetList) {
        this.endedFreeBets = freeBetList;
    };
    FreeBetStore.prototype.selectFreeBet = function (freeBet) {
        if (this.activeFreeBet.id === freeBet.id) {
            this.resetActiveFreeBet();
        }
        else {
            this.setActivateFreeBet(freeBet);
        }
    };
    FreeBetStore.prototype.selectFreeBetInStatus = function (freeBetId) {
        var useFreeBetItem = this.freeBets.find(function (freeBet) { return freeBet.id === freeBetId; });
        if ((useFreeBetItem === null || useFreeBetItem === void 0 ? void 0 : useFreeBetItem.remainingCount) === 0) {
            this.setAwardedFreeBet(null);
            this.resetActiveFreeBet();
        }
        else {
            this.freeBetsStatusChanger(freeBetId);
            this.setActivateFreeBet(useFreeBetItem);
        }
    };
    FreeBetStore.prototype.handleUseLater = function (freeBetId) {
        var _this = this;
        var useFreeBetItem = this.freeBets.find(function (freeBet) { return freeBet.id === freeBetId; });
        if (useFreeBetItem === null || useFreeBetItem === void 0 ? void 0 : useFreeBetItem.remainingCount) {
            setTimeout(function () { return _this.freeBetsStatusChanger(freeBetId); }, 0);
        }
        else {
            this.setAwardedFreeBet(null);
        }
    };
    Object.defineProperty(FreeBetStore.prototype, "unUseFreeBetCount", {
        get: function () {
            return this.freeBets.reduce(function (acc, freeBet) {
                return (freeBet === null || freeBet === void 0 ? void 0 : freeBet.status) !== FreeBetsStatus.Expired && (freeBet === null || freeBet === void 0 ? void 0 : freeBet.status) !== FreeBetsStatus.Finished
                    ? acc + freeBet.remainingCount
                    : acc + 0;
            }, 0);
        },
        enumerable: false,
        configurable: true
    });
    FreeBetStore.prototype.setExpireDayCount = function (count) {
        this.expireDayCount = count;
    };
    FreeBetStore.prototype.handleExpireFreeBets = function (freeBetId) {
        var updatedExpireFreeBetsData = this.freeBets.map(function (item) {
            return item.id === freeBetId ? __assign(__assign({}, item), { status: FreeBetsStatus.Expired }) : item;
        });
        this.setFreeBets(updatedExpireFreeBetsData);
    };
    FreeBetStore.prototype.createExpireDate = function () {
        var checkDateNow = +new Date();
        var dayCount = +new Date(this.firstExpireFreeBetsData[0].expireDate) - checkDateNow;
        this.setExpireDayCount(dayCount);
    };
    FreeBetStore.prototype.checkFirstExpireFreeBets = function () {
        var inProcessFreeBets = this.freeBets
            .filter(function (item) { return item.status === FreeBetsStatus.Accepted || item.status === FreeBetsStatus.Pending; })
            .sort(function (a, b) { return +new Date(b.receiveDateForSort) - +new Date(a.receiveDateForSort); });
        if (inProcessFreeBets.length) {
            var firstExpireFreeBet_1 = inProcessFreeBets[0];
            var currentExpireFreeBets = inProcessFreeBets.filter(function (item) { return item.expireDate === firstExpireFreeBet_1.expireDate; });
            if (currentExpireFreeBets.length) {
                var firstExpireFreeBets = currentExpireFreeBets.map(function (item) { return ({
                    freeBetId: item.id,
                    expireDate: item.expireDate,
                    isExpire: false,
                }); });
                this.setFirstExpireFreeBetsData(firstExpireFreeBets);
                this.createExpireDate();
                this.changeExpireFreeBetsStatus();
            }
        }
    };
    FreeBetStore.prototype.setFirstExpireFreeBetsData = function (freeBetsList) {
        this.firstExpireFreeBetsData = freeBetsList;
    };
    FreeBetStore.prototype.changeExpireFreeBetsStatus = function () {
        var _this = this;
        if (this.expireDayCount <= TimeoutMaxValue.maximumDelay) {
            if (this.firstExpireFreeBetTimeOutId || this.firstExpireFreeBetTimeOutId === 0) {
                clearTimeout(this.firstExpireFreeBetTimeOutId);
            }
            this.firstExpireFreeBetTimeOutId = setTimeout(function () {
                var updatedExpireFreeBetsData = _this.firstExpireFreeBetsData.map(function (item) { return (__assign(__assign({}, item), { isExpire: true })); });
                _this.setFirstExpireFreeBetsData(updatedExpireFreeBetsData);
                _this.firstExpireFreeBetsData.forEach(function (item) {
                    _this.handleExpireFreeBets(item.freeBetId);
                    if (item.freeBetId === _this.activeFreeBet.id) {
                        _this.resetActiveFreeBet();
                    }
                });
                _this.resetOldAndGenerateNewExpireData();
                _this.setFreeBets(_this.freeBetsSortFunctional(_this.freeBets));
            }, this.expireDayCount);
        }
    };
    FreeBetStore.prototype.resetOldAndGenerateNewExpireData = function () {
        this.setFirstExpireFreeBetsData([]);
        this.setExpireDayCount(null);
        this.checkFirstExpireFreeBets();
    };
    FreeBetStore.prototype.freeBetsStatusChanger = function (freeBetId) {
        var updateFreeBetsData, remainingAwardedFreeBets_1, error_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiServices.get(ApiServiceTypes.BetsService).updateFreeBetStatus({ freeBetId: freeBetId })];
                case 1:
                    _a.sent();
                    updateFreeBetsData = this.freeBets.map(function (freeBet) {
                        if (freeBet.id === freeBetId) {
                            return __assign(__assign({}, freeBet), { status: FreeBetsStatus.Accepted });
                        }
                        return freeBet;
                    });
                    this.setFreeBets(updateFreeBetsData);
                    remainingAwardedFreeBets_1 = updateFreeBetsData.find(function (item) { return item.id !== freeBetId && item.status === FreeBetsStatus.Pending; });
                    this.setAwardedFreeBet(null);
                    if (remainingAwardedFreeBets_1) {
                        setTimeout(function () { return _this.setAwardedFreeBet(remainingAwardedFreeBets_1); }, 500);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    };
    FreeBetStore.prototype.handleAwardedFreeBets = function (data) {
        var userId = userInfoStore.userId;
        var awardedFreeBets = data.filter(function (freeBet) { return freeBet.userId === +userId; });
        if (awardedFreeBets && awardedFreeBets.length) {
            awardedFreeBets = awardedFreeBets.map(function (freeBet) { return (__assign(__assign({}, freeBet), { expireDateFreeBet: formatDate(new Date(freeBet.expireDate), 'DD.MM.YY'), expiredTime: formatDate(new Date(freeBet.expireDate), 'hh:mm'), receiveDate: formatDate(new Date(freeBet.receiveDate), 'DD.MM.YY'), freeBetReceiveDate: formatDate(new Date(freeBet.receiveDate), 'DD.MM.YY') })); });
            this.updatedFreeBets(awardedFreeBets);
            this.resetOldAndGenerateNewExpireData();
        }
        if (!this.awardedFreeBet) {
            var findResult = awardedFreeBets.find(function (pendingFreeBet) { return pendingFreeBet.status === FreeBetsStatus.Pending; });
            if (findResult) {
                this.setAwardedFreeBet(findResult);
            }
        }
    };
    FreeBetStore.prototype.handleEndedFreeBets = function (data) {
        var userId = userInfoStore.userId;
        var userEndedFreeBets = data.filter(function (freeBet) { return freeBet.userId === +userId; });
        if (userEndedFreeBets === null || userEndedFreeBets === void 0 ? void 0 : userEndedFreeBets.length) {
            this.setEndedFreeBets(userEndedFreeBets);
        }
        this.resetOldAndGenerateNewExpireData();
    };
    FreeBetStore.prototype.handleFreeBetsInitialData = function (userFreeBets, isGameInitial) {
        var _this = this;
        if (isGameInitial === void 0) { isGameInitial = false; }
        var freeBetIsUsed = false;
        if (userFreeBets) {
            var userId_1 = userInfoStore.userId;
            var convertFreeBetData = userFreeBets.map(function (freeBet) {
                var expireDateFreeBet = formatDate(new Date(freeBet.expireDate), 'DD.MM.YY');
                var expiredTime = formatDate(new Date(freeBet.expireDate), 'hh:mm');
                var freeBetReceiveDate = formatDate(new Date(freeBet.receiveDate), 'DD.MM.YY');
                if (_this.activeFreeBet.id &&
                    freeBet.id === _this.activeFreeBet.id &&
                    freeBet.remainingCount === 0 &&
                    isGameInitial) {
                    freeBetIsUsed = true;
                }
                return __assign(__assign({}, freeBet), { expireDateFreeBet: expireDateFreeBet, expiredTime: expiredTime, receiveDate: freeBetReceiveDate, receiveDateForSort: freeBet.receiveDate });
            });
            if (freeBetIsUsed) {
                this.resetActiveFreeBet();
            }
            if (this.freeBetEnded) {
                this.setFreeBetEnded(null);
            }
            convertFreeBetData = this.freeBetsSortFunctional(convertFreeBetData);
            var awardedFreeBet = convertFreeBetData.find(function (freeBet) { return freeBet.userId === +userId_1 && freeBet.status === FreeBetsStatus.Pending; });
            this.setFreeBets(convertFreeBetData);
            this.setAwardedFreeBet(awardedFreeBet);
            if (isGameInitial) {
                this.checkFirstExpireFreeBets();
            }
            else {
                this.resetOldAndGenerateNewExpireData();
            }
        }
    };
    FreeBetStore.prototype.handleFreeBetDoBetResult = function (freeBetId) {
        var _this = this;
        if (freeBetId) {
            var disableActiveFreeBet_1 = false;
            var updatedFreeBets = this.freeBets.map(function (freeBet) {
                if (freeBet.id === freeBetId) {
                    if (freeBet.remainingCount - 1 === 0) {
                        disableActiveFreeBet_1 = true;
                    }
                    return __assign(__assign({}, freeBet), { remainingCount: freeBet.remainingCount - 1, status: disableActiveFreeBet_1 ? FreeBetsStatus.Finished : FreeBetsStatus.Accepted });
                }
                return freeBet;
            });
            var updatedActiveFreeBet = updatedFreeBets.find(function (freeBet) { return freeBet.id === _this.activeFreeBet.id; });
            if (updatedActiveFreeBet) {
                this.setActivateFreeBet(updatedActiveFreeBet);
            }
            if (disableActiveFreeBet_1) {
                this.resetActiveFreeBet();
            }
            this.setFreeBets(updatedFreeBets);
        }
    };
    FreeBetStore.prototype.handleFreeBetEndedData = function () {
        var _this = this;
        var _a, _b;
        var _loop_1 = function () {
            var finishedFreeBet = this_1.endedFreeBets.shift();
            var endedFreeBet = this_1.freeBets.find(function (freeBet) { return freeBet.id === finishedFreeBet.freeBetId; });
            if (endedFreeBet) {
                endedFreeBet.totalWin = finishedFreeBet.totalAmount;
                var updatedFreeBets = this_1.freeBets.map(function (freeBet) {
                    return freeBet.id === endedFreeBet.id
                        ? __assign(__assign({}, freeBet), { totalWin: endedFreeBet.totalWin, status: FreeBetsStatus.Finished }) : freeBet;
                });
                if (((_b = this_1.awardedFreeBet) === null || _b === void 0 ? void 0 : _b.id) === finishedFreeBet.freeBetId) {
                    this_1.setAwardedFreeBet(null);
                }
                this_1.setFreeBets(this_1.freeBetsSortFunctional(updatedFreeBets));
                this_1.setFreeBetEnded(endedFreeBet);
                setTimeout(function () { return _this.setFreeBetEnded(null); }, 1500);
            }
        };
        var this_1 = this;
        while ((_a = this.endedFreeBets) === null || _a === void 0 ? void 0 : _a.length) {
            _loop_1();
        }
    };
    FreeBetStore.prototype.freeBetTotalWinCalculator = function (winData) {
        if (winData.freeBetId && !applicationStore.isDemo) {
            this.freeBets.forEach(function (freeBet) {
                if (freeBet.id === winData.freeBetId) {
                    freeBet.totalWin = parseNumberByPrecision(freeBet.totalWin + winData.winAmount, 1, 2);
                }
            });
        }
    };
    FreeBetStore.prototype.freeBetsSortFunctional = function (freeBets) {
        freeBets.sort(function (a, b) { return +new Date(b.receiveDateForSort) - +new Date(a.receiveDateForSort); });
        var filteredFreeBetsByPendingOrAccepted = freeBets.filter(function (item) { return item.status === FreeBetsStatus.Accepted || item.status === FreeBetsStatus.Pending; });
        var filteredFreeBetsByFinishedOrExpired = freeBets.filter(function (item) { return item.status !== FreeBetsStatus.Accepted && item.status !== FreeBetsStatus.Pending; });
        return __spreadArray(__spreadArray([], __read(filteredFreeBetsByPendingOrAccepted), false), __read(filteredFreeBetsByFinishedOrExpired), false);
    };
    return FreeBetStore;
}());
var freeBetStore = new FreeBetStore();

var FreeChipsStore = /** @class */ (function () {
    function FreeChipsStore() {
        this.freeChipsList = [];
        this.freeChipInfo = null;
        this.freeChipAwardedOrEnded = null;
        this.activeFreeChip = null;
        this.freeChipLimits = null;
        this.freeChipInLobby = null;
        this.freeChipPopupName = '';
        makeObservable(this, {
            freeChipInfo: observable.deep,
            freeChipsList: observable.deep,
            activeFreeChip: observable.deep,
            freeChipLimits: observable.deep,
            freeChipInLobby: observable.deep,
            freeChipAwardedOrEnded: observable.deep,
            freeChipPopupName: observable.deep,
            setFreeChipsList: action.bound,
            updateFreeChipList: action.bound,
            setFreeChipInfo: action.bound,
            setFreeChipInLobby: action.bound,
            setFreeChipAwardedOrEnded: action.bound,
            setActiveFreeChip: action.bound,
            setFreeChipLimits: action.bound,
            setFreeChipPopupName: action.bound,
            handleShowAwardedFreeChip: action.bound,
            handleEndedFreeChip: action.bound,
            handleFreeChipRemainingCountDown: action.bound,
            resetActiveFreeChip: action.bound,
            handleUpdateFreeChipTotalWin: action.bound,
            handleChangeFreeChipStatus: action.bound,
            sendClaimFreeBet: action.bound,
            resetFreeChipStoreData: action.bound,
        });
    }
    FreeChipsStore.prototype.handleShowAwardedFreeChip = function () {
        var pendingFreeChipIndex = this.freeChipsList.findIndex(function (item) { return item.status === FreeBetsStatus.Pending; });
        if (pendingFreeChipIndex >= 0) {
            this.setFreeChipAwardedOrEnded(this.freeChipsList[pendingFreeChipIndex]);
            this.setFreeChipPopupName(FreeChipNames.freeChipWin);
        }
    };
    FreeChipsStore.prototype.handleEndedFreeChip = function (endedFreeChips, showPopupTimer) {
        var _this = this;
        if (showPopupTimer === void 0) { showPopupTimer = 3000; }
        endedFreeChips.forEach(function (endedFreeChip, i) {
            var finishedFreeChipIndex = _this.freeChipsList.findIndex(function (item) { return item.id === endedFreeChip.freeBetId; });
            if (finishedFreeChipIndex >= 0) {
                setTimeout(function () {
                    _this.setFreeChipAwardedOrEnded(__assign(__assign({}, _this.freeChipsList[finishedFreeChipIndex]), endedFreeChip));
                    _this.setFreeChipPopupName(FreeChipNames.freeChipEnded);
                    _this.freeChipsList[finishedFreeChipIndex] = __assign(__assign({}, _this.freeChipsList[finishedFreeChipIndex]), { status: FreeBetsStatus.Finished, totalWin: endedFreeChip.totalAmount });
                    setTimeout(function () {
                        _this.setFreeChipPopupName(null);
                        _this.setFreeChipAwardedOrEnded(null);
                    }, i * showPopupTimer + showPopupTimer);
                }, i * showPopupTimer);
            }
        });
    };
    // this would not be called in bet closed
    FreeChipsStore.prototype.sendClaimFreeBet = function (_a) {
        var _this = this;
        var freeChip = _a.freeChip, actionType = _a.actionType, _b = _a.isClickable, isClickable = _b === void 0 ? false : _b, _c = _a.callBack, callBack = _c === void 0 ? null : _c;
        var claimedFreeChipIndex = this.freeChipsList.findIndex(function (item) { return item.id === freeChip.id; });
        if (claimedFreeChipIndex >= 0) {
            ApiServices.get(ApiServiceTypes.FreeChipService)
                .sendClaimFreeBet(this.freeChipsList[claimedFreeChipIndex].id)
                .then(function () {
                _this.freeChipsList[claimedFreeChipIndex].status = FreeBetsStatus.Accepted;
                if (actionType === FreeChipPopupActions.USE_NOW && isClickable && !callBack) {
                    _this.setActiveFreeChip(freeChip);
                    _this.setFreeChipPopupName(null);
                }
                else {
                    _this.setFreeChipPopupName(null);
                    if (callBack) {
                        callBack();
                    }
                }
                _this.setFreeChipAwardedOrEnded(null);
                _this.handleShowAwardedFreeChip();
            })
                .catch(function () { });
        }
    };
    FreeChipsStore.prototype.setFreeChipsList = function (list) {
        this.freeChipsList = list;
        this.handleShowAwardedFreeChip();
    };
    FreeChipsStore.prototype.setFreeChipInLobby = function (freeChip) {
        this.freeChipInLobby = freeChip;
    };
    FreeChipsStore.prototype.updateFreeChipList = function (freeChips) {
        this.freeChipsList = __spreadArray(__spreadArray([], __read(this.freeChipsList), false), __read(freeChips), false);
        this.handleShowAwardedFreeChip();
    };
    FreeChipsStore.prototype.setFreeChipAwardedOrEnded = function (freeChip) {
        this.freeChipAwardedOrEnded = freeChip;
    };
    FreeChipsStore.prototype.setFreeChipInfo = function (freeChip) {
        this.freeChipInfo = freeChip;
        this.setFreeChipPopupName(FreeChipNames.freeChipInfo);
    };
    FreeChipsStore.prototype.setActiveFreeChip = function (freeChip) {
        var limits = gameConfigStore.limits;
        if (this.activeFreeChip && this.activeFreeChip.id === freeChip.id) {
            this.resetActiveFreeChip();
            return;
        }
        if (limits) {
            var additionalLimits_1 = limits.additionalLimits, maxBet_1 = limits.maxBet;
            var freeChipLimits = Object.keys(additionalLimits_1).reduce(function (acc, cur) {
                acc.additionalLimits[cur] = __assign(__assign({}, additionalLimits_1[cur]), { maxBet: freeChip.amount > maxBet_1 ? maxBet_1 : freeChip.amount });
                return acc;
            }, {
                additionalLimits: {},
            });
            this.setFreeChipLimits(freeChipLimits);
        }
        this.activeFreeChip = freeChip;
        if (this.freeChipInLobby) {
            this.freeChipInLobby = null;
        }
    };
    FreeChipsStore.prototype.setFreeChipLimits = function (limits) {
        this.freeChipLimits = limits;
    };
    FreeChipsStore.prototype.setFreeChipPopupName = function (name) {
        this.freeChipPopupName = name;
    };
    FreeChipsStore.prototype.handleUpdateFreeChipTotalWin = function (winAmount) {
        var _this = this;
        var activeFreeChipIndex = this.freeChipsList.findIndex(function (item) { return item.id === _this.activeFreeChip.id; });
        this.freeChipsList[activeFreeChipIndex].totalWin += winAmount;
    };
    FreeChipsStore.prototype.handleChangeFreeChipStatus = function (index, newStatus) {
        var _a;
        if ((_a = this.freeChipsList) === null || _a === void 0 ? void 0 : _a[index]) {
            this.freeChipsList[index].status = newStatus;
        }
    };
    FreeChipsStore.prototype.handleFreeChipRemainingCountDown = function (id) {
        var freeChipIndex = this.freeChipsList.findIndex(function (item) { return item.id === id; });
        if (freeChipIndex >= 0) {
            this.freeChipsList[freeChipIndex].remainingCount -= 1;
            this.activeFreeChip.remainingCount = this.freeChipsList[freeChipIndex].remainingCount;
            if (!this.freeChipsList[freeChipIndex].remainingCount) {
                this.freeChipsList[freeChipIndex].status = FreeBetsStatus.Finished;
            }
        }
    };
    FreeChipsStore.prototype.resetActiveFreeChip = function () {
        this.activeFreeChip = null;
        this.freeChipLimits = null;
    };
    FreeChipsStore.prototype.resetFreeChipStoreData = function () {
        this.freeChipsList = [];
        this.freeChipInfo = null;
        this.freeChipAwardedOrEnded = null;
        this.activeFreeChip = null;
        this.freeChipLimits = null;
        this.freeChipPopupName = '';
    };
    return FreeChipsStore;
}());
var freeChipsStore = new FreeChipsStore();

var UserSettingsStore = /** @class */ (function () {
    function UserSettingsStore() {
        var _a, _b;
        this.localStorageSuffix = '_userSettings';
        this.soundService = null;
        this.localStorageKey = '';
        this.isAnimationOn = true;
        this.isMusicOn = true;
        this.musicVolume = 0.5;
        this.isSoundOn = true;
        this.soundVolume = 0.5;
        this.gameThemeType = ((_a = parseQuery(window.location.search)) === null || _a === void 0 ? void 0 : _a[DefaultQueryParams.Theme])
            ? +GameTheme[(_b = parseQuery(window.location.search)) === null || _b === void 0 ? void 0 : _b[DefaultQueryParams.Theme]]
            : GameTheme.Standart;
        this.isDarkModeOn = false;
        this.isWinterModeOn = false;
        this.isFullScreen = false;
        this.allowFullScreen = false;
        this.isHalfCashOutOn = true;
        this.gameSpecificLocalStorageData = {};
        makeObservable(this, {
            isMusicOn: observable,
            isSoundOn: observable,
            soundVolume: observable,
            musicVolume: observable,
            isDarkModeOn: observable,
            isFullScreen: observable,
            isAnimationOn: observable,
            gameThemeType: observable,
            isWinterModeOn: observable,
            allowFullScreen: observable,
            isHalfCashOutOn: observable,
            gameSpecificLocalStorageData: observable.deep,
            setIsMusicOn: action.bound,
            setIsMusicOnValue: action.bound,
            setMusicVolume: action.bound,
            setIsSoundOn: action.bound,
            setSoundVolume: action.bound,
            setIsDarkModeOn: action.bound,
            setGameThemeType: action.bound,
            setIsWinterModeOn: action.bound,
            setIsMusicOnAndIsSoundOn: action.bound,
            setIsAnimationOn: action.bound,
            localStorageAndUserSettingsInit: action.bound,
            setIsFullScreen: action.bound,
            toggleFullscreen: action.bound,
            openFullScreen: action.bound,
            closeFullScreen: action.bound,
            setAllowFullScreen: action.bound,
            setIsHalfCashOutOn: action.bound,
            setGameSpecificLocalStorageDataByKey: action.bound,
        });
    }
    UserSettingsStore.prototype.localStorageAndUserSettingsInit = function (_a) {
        var gamePrefix = _a.gameName, soundService = _a.soundService, updatedDefaultSettings = _a.updatedDefaultSettings, _b = _a.gameSpecificData, gameSpecificData = _b === void 0 ? {} : _b;
        this.localStorageKey = gamePrefix + this.localStorageSuffix;
        this.soundService = soundService;
        var _c = parseQuery(window.location.search), _d = DefaultQueryParams.Theme, themeName = _c[_d];
        var userSettings = JSON.parse(localStorage.getItem(this.localStorageKey));
        this.gameSpecificLocalStorageData = gameSpecificData;
        var defSettings = __assign(__assign({ isMusicOn: this.isMusicOn, musicVolume: this.musicVolume, isSoundOn: this.isSoundOn, soundVolume: this.soundVolume, isDarkModeOn: this.isDarkModeOn, isWinterModeOn: this.isWinterModeOn, isAnimationOn: this.isAnimationOn, gameThemeType: this.gameThemeType, isHalfCashOutOn: this.isHalfCashOutOn }, updatedDefaultSettings), gameSpecificData);
        if (userSettings === null || Object.keys(defSettings).length !== Object.keys(userSettings).length) {
            localStorage.setItem(this.localStorageKey, JSON.stringify(defSettings));
        }
        else {
            var isMusicOn = userSettings.isMusicOn, musicVolume = userSettings.musicVolume, isSoundOn = userSettings.isSoundOn, soundVolume = userSettings.soundVolume, isDarkModeOn = userSettings.isDarkModeOn, isWinterModeOn = userSettings.isWinterModeOn, isAnimationOn = userSettings.isAnimationOn, gameThemeType = userSettings.gameThemeType, isHalfCashOutOn = userSettings.isHalfCashOutOn, rest = __rest(userSettings, ["isMusicOn", "musicVolume", "isSoundOn", "soundVolume", "isDarkModeOn", "isWinterModeOn", "isAnimationOn", "gameThemeType", "isHalfCashOutOn"]);
            this.isMusicOn = isMusicOn;
            this.musicVolume = musicVolume;
            this.isSoundOn = isSoundOn;
            this.soundVolume = soundVolume;
            this.isDarkModeOn = isDarkModeOn;
            this.isWinterModeOn = isWinterModeOn;
            this.isAnimationOn = isAnimationOn;
            this.gameThemeType = gameThemeType;
            this.isHalfCashOutOn = isHalfCashOutOn;
            this.gameSpecificLocalStorageData = rest;
        }
        if (this.gameThemeType && this.gameThemeType !== +GameTheme[themeName]) {
            this.gameThemeType = GameTheme[GameThemeNames.Standart];
        }
    };
    UserSettingsStore.prototype.updateLocalStorage = function (updatedSettings) {
        if (localStorage.getItem(this.localStorageKey)) {
            var updatedUserSettings = __assign(__assign({}, JSON.parse(localStorage.getItem(this.localStorageKey))), updatedSettings);
            localStorage.setItem(this.localStorageKey, JSON.stringify(updatedUserSettings));
        }
        else {
            console.error('PLEASE INIT YOUR LOCAL STORAGE');
        }
    };
    Object.defineProperty(UserSettingsStore.prototype, "localStorageData", {
        get: function () {
            return JSON.parse(localStorage.getItem(this.localStorageKey));
        },
        enumerable: false,
        configurable: true
    });
    UserSettingsStore.prototype.setIsAnimationOn = function () {
        this.updateLocalStorage({
            isAnimationOn: !this.isAnimationOn,
        });
        this.isAnimationOn = !this.isAnimationOn;
    };
    UserSettingsStore.prototype.setIsMusicOnAndIsSoundOn = function (isMuteAll) {
        if (isMuteAll === void 0) { isMuteAll = false; }
        if (this.isMusicOn || this.isSoundOn || isMuteAll) {
            this.isMusicOn = false;
            this.isSoundOn = false;
            this.soundService.muteMusic(true);
            this.soundService.muteSounds(true);
        }
        else {
            this.isMusicOn = true;
            this.isSoundOn = true;
            this.soundService.muteMusic(false);
            this.soundService.muteSounds(false);
        }
        this.updateLocalStorage({
            isMusicOn: this.isMusicOn,
            isSoundOn: this.isSoundOn,
        });
    };
    UserSettingsStore.prototype.setMusicVolume = function (musicVolume) {
        this.soundService.changeMusicVolume(musicVolume);
        var isMusicOn = +musicVolume === 0 || !this.isMusicOn ? !this.isMusicOn : this.isMusicOn;
        this.updateLocalStorage({
            musicVolume: musicVolume,
            isMusicOn: isMusicOn,
        });
        this.musicVolume = musicVolume;
        this.isMusicOn = isMusicOn;
        this.soundService.muteMusic(!isMusicOn);
    };
    UserSettingsStore.prototype.setIsSoundOn = function (bool) {
        var hasValidArgument = typeof bool === 'boolean';
        this.soundService.muteSounds(hasValidArgument ? bool : this.isSoundOn);
        this.isSoundOn = hasValidArgument ? bool : !this.isSoundOn;
        this.soundVolume = this.isSoundOn ? 0.5 : 0;
        this.updateLocalStorage({
            isSoundOn: this.isSoundOn,
            soundVolume: this.soundVolume,
        });
    };
    UserSettingsStore.prototype.setIsMusicOn = function (bool) {
        var hasValidArgument = typeof bool === 'boolean';
        this.soundService.muteMusic(hasValidArgument ? bool : this.isMusicOn);
        this.isMusicOn = hasValidArgument ? bool : !this.isMusicOn;
        this.musicVolume = this.isMusicOn ? 0.5 : 0;
        this.updateLocalStorage({
            isMusicOn: this.isMusicOn,
            musicVolume: this.musicVolume,
        });
    };
    UserSettingsStore.prototype.setSoundVolume = function (soundVolume) {
        this.soundService.changeSoundsVolume(soundVolume);
        var isSoundOn = +soundVolume === 0 || !this.isSoundOn ? !this.isSoundOn : this.isSoundOn;
        this.updateLocalStorage({
            soundVolume: soundVolume,
            isSoundOn: isSoundOn,
        });
        this.soundVolume = soundVolume;
        this.isSoundOn = isSoundOn;
        this.soundService.muteSounds(!isSoundOn);
    };
    UserSettingsStore.prototype.setIsDarkModeOn = function (defaultValue) {
        if (defaultValue === void 0) { defaultValue = undefined; }
        if (defaultValue === undefined) {
            this.updateLocalStorage({
                isDarkModeOn: !this.isDarkModeOn,
            });
        }
        this.isDarkModeOn = defaultValue !== undefined ? defaultValue : !this.isDarkModeOn;
    };
    UserSettingsStore.prototype.setIsWinterModeOn = function () {
        this.updateLocalStorage({
            isWinterModeOn: !this.isWinterModeOn,
        });
        this.isWinterModeOn = !this.isWinterModeOn;
    };
    UserSettingsStore.prototype.setGameThemeType = function () {
        var _a = parseQuery(window.location.search), _b = DefaultQueryParams.Theme, themeName = _a[_b];
        if (!!this.gameThemeType || !GameTheme[themeName]) {
            this.gameThemeType = GameTheme[GameThemeNames.Standart];
        }
        else {
            this.gameThemeType = +GameTheme[themeName];
        }
        this.updateLocalStorage({
            gameThemeType: this.gameThemeType,
        });
    };
    UserSettingsStore.prototype.setIsMusicOnValue = function (state) {
        this.isMusicOn = state;
    };
    Object.defineProperty(UserSettingsStore.prototype, "document", {
        get: function () {
            return window.document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSettingsStore.prototype, "htmlElement", {
        get: function () {
            return document.documentElement;
        },
        enumerable: false,
        configurable: true
    });
    UserSettingsStore.prototype.setIsFullScreen = function (bool) {
        this.isFullScreen = bool;
    };
    UserSettingsStore.prototype.setAllowFullScreen = function (bool) {
        this.allowFullScreen = bool;
    };
    UserSettingsStore.prototype.setIsHalfCashOutOn = function () {
        this.updateLocalStorage({
            isHalfCashOutOn: !this.isHalfCashOutOn,
        });
        this.isHalfCashOutOn = !this.isHalfCashOutOn;
    };
    UserSettingsStore.prototype.toggleFullscreen = function () {
        !this.isFullScreen ? this.openFullScreen() : this.closeFullScreen();
    };
    UserSettingsStore.prototype.openFullScreen = function () {
        switch (true) {
            case !!this.htmlElement.requestFullscreen:
                this.htmlElement.requestFullscreen().catch(function (err) { return console.log(err); });
                break;
            case !!this.htmlElement.mozRequestFullScreen /* Firefox */:
                this.htmlElement.mozRequestFullScreen();
                break;
            case !!this.htmlElement.webkitRequestFullscreen /* Chrome, Safari and Opera */:
                this.htmlElement.webkitRequestFullscreen();
                break;
            case !!this.htmlElement.msRequestFullscreen /* IE/Edge */:
                this.htmlElement.msRequestFullscreen();
                break;
        }
    };
    UserSettingsStore.prototype.closeFullScreen = function () {
        switch (true) {
            case !!this.document.exitFullscreen:
                this.document.exitFullscreen().catch(function (err) { return console.log(err); });
                break;
            case !!this.document.mozCancelFullScreen /* Firefox */:
                this.document.mozCancelFullScreen();
                break;
            case !!this.document.webkitExitFullscreen /* Chrome, Safari and Opera */:
                this.document.webkitExitFullscreen();
                break;
            case !!this.document.msExitFullscreen /* IE/Edge */:
                this.document.msExitFullscreen();
                break;
        }
    };
    UserSettingsStore.prototype.setGameSpecificLocalStorageDataByKey = function (gameSpecificLocalStorageDataKey, gameSpecificLocalStorageDataValue) {
        this.gameSpecificLocalStorageData[gameSpecificLocalStorageDataKey] = gameSpecificLocalStorageDataValue;
        this.updateLocalStorage(this.gameSpecificLocalStorageData);
    };
    return UserSettingsStore;
}());
var userSettingsStore = new UserSettingsStore();

var TableBetHistoryStore = /** @class */ (function () {
    function TableBetHistoryStore() {
        this.fetchPaths = BetsFetchDefaultPaths;
        this.fetchParamNames = BetsFetchDefaultParamNames;
        this.queryState = {
            skip: 0,
            take: 15,
        };
        this.selectedHistoryRow = null;
        this.showRoundBet = false;
        this.firstStep = {
            data: {
                items: [],
                count: 0,
            },
            pending: false,
        };
        this.thirdStep = {
            data: {},
            pending: false,
        };
        this.secondStep = {
            data: {},
            pending: false,
        };
        makeObservable(this, {
            queryState: observable,
            selectedHistoryRow: observable.deep,
            firstStep: observable.deep,
            thirdStep: observable.deep,
            secondStep: observable.deep,
            fetchPaths: observable.deep,
            fetchParamNames: observable.deep,
            showRoundBet: observable,
            getFirstStep: flow.bound,
            getSecondStep: flow.bound,
            getThirdStep: flow.bound,
            removeThirdStep: action.bound,
            setSelectedHistoryRow: action.bound,
            setFirstStepPending: action.bound,
            setSecondStepPending: action.bound,
            setThirdStepPending: action.bound,
            setFetchPaths: action.bound,
            setFetchParamNames: action.bound,
            betsService: computed,
        });
    }
    Object.defineProperty(TableBetHistoryStore.prototype, "betsService", {
        get: function () {
            return ApiServices.get(ApiServiceTypes.BetsService);
        },
        enumerable: false,
        configurable: true
    });
    TableBetHistoryStore.prototype.setSelectedHistoryRow = function (payload) {
        this.selectedHistoryRow = payload;
    };
    TableBetHistoryStore.prototype.setShowRoundBet = function (arg) {
        this.showRoundBet = arg;
    };
    TableBetHistoryStore.prototype.setFirstStepPending = function () {
        this.firstStep.pending = !this.firstStep.pending;
    };
    TableBetHistoryStore.prototype.handleBetHistoryUpdate = function () {
        var getDay = getStartEndDay(moment().format());
        this.getFirstStep(this.queryState);
        this.getSecondStep({
            key: moment(getDay.startDate).format('YYYY-MM-DDT00:00:00'),
            date: getDay,
        });
    };
    TableBetHistoryStore.prototype.getFirstStep = function (payload) {
        var _a, _b, gameId, concat, options, result, items, all, firstStep, _c, firstData, firstStepData;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _a = parseQuery(window.location.search), _b = DefaultQueryParams.GameId, gameId = _a[_b];
                    concat = payload.concat, options = __rest(payload, ["concat"]);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    this.setFirstStepPending();
                    return [4 /*yield*/, this.betsService.getBets(__assign({ gameId: gameId }, options), this.fetchPaths.FirstStep)];
                case 2:
                    result = (_e.sent()).data.result;
                    items = result.items, all = __rest(result, ["items"]);
                    firstStep = __assign(__assign({}, all), { items: __spreadArray([], __read(items.sort(function (a, b) { return +moment(b.date) - +moment(a.date); })), false) });
                    if (firstStep.items.length && !((_d = Object.keys(this.secondStep.data)) === null || _d === void 0 ? void 0 : _d.length)) {
                        _c = __read(firstStep.items, 1), firstData = _c[0];
                        this.getSecondStep({ key: firstData.date, date: getStartEndDay(firstData.date) });
                    }
                    if (concat) {
                        firstStepData = this.firstStep.data;
                        this.firstStep = {
                            data: {
                                items: __spreadArray(__spreadArray([], __read(firstStepData.items), false), __read(firstStep.items), false).sort(function (a, b) { return +moment(b.date) - +moment(a.date); }),
                                count: firstStep.count,
                            },
                            pending: false,
                        };
                    }
                    else {
                        this.firstStep = {
                            data: firstStep,
                            pending: false,
                        };
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _e.sent();
                    this.setFirstStepPending();
                    iframeService.reloadFrame();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.setSecondStepPending = function () {
        this.secondStep.pending = !this.secondStep.pending;
    };
    TableBetHistoryStore.prototype.getSecondStep = function (payload) {
        var _a, _b, gameId, key, date, result;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = parseQuery(window.location.search), _b = DefaultQueryParams.GameId, gameId = _a[_b];
                    key = payload.key, date = payload.date;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    this.setSecondStepPending();
                    return [4 /*yield*/, this.betsService.getBets(__assign({ gameId: gameId }, date), this.fetchPaths.SecondStep)];
                case 2:
                    result = (_d.sent()).data.result;
                    this.secondStep = {
                        data: __assign(__assign({}, this.secondStep.data), (_c = {}, _c[key] = result.items, _c)),
                        pending: false,
                    };
                    return [3 /*break*/, 4];
                case 3:
                    _d.sent();
                    this.setSecondStepPending();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.setThirdStepPending = function () {
        this.thirdStep.pending = !this.thirdStep.pending;
    };
    TableBetHistoryStore.prototype.getThirdStep = function (option) {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    this.setThirdStepPending();
                    return [4 /*yield*/, this.betsService.getBets(option, this.fetchPaths.ThirdStep)];
                case 1:
                    result = (_a.sent()).data.result;
                    this.thirdStep = {
                        data: Array.isArray(result.items) ? result.items[0] : result,
                        pending: false,
                    };
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    this.setThirdStepPending();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.removeThirdStep = function () {
        this.thirdStep = {
            data: {},
            pending: false,
        };
    };
    TableBetHistoryStore.prototype.setFetchPaths = function (fetchPaths) {
        this.fetchPaths = __assign(__assign({}, this.fetchPaths), fetchPaths);
    };
    TableBetHistoryStore.prototype.setFetchParamNames = function (fetchParamNames) {
        this.fetchParamNames = __assign(__assign({}, this.fetchParamNames), fetchParamNames);
    };
    return TableBetHistoryStore;
}());
var tableBetHistoryStore = new TableBetHistoryStore();

export { ApplicationStore as A, BaseLiveConnection as B, ChatService as C, TableBetHistoryStore as D, profileAvatarStore as E, FreeChipService as F, GameLiveConnection as G, ProfileAvatarStore as H, IframeService as I, LobbyLiveConnection as L, PostMessage as P, RoundsService as R, StatisticsService as S, TranslationService as T, UsersService as U, PostMessageListenerMessages as a, BetsService as b, chatService as c, betStore as d, BetsStore as e, PopupStore as f, LobbyStore as g, httpClient as h, iframeService as i, freeBetStore as j, FreeBetStore as k, lobbyStore as l, UserInfoStore as m, freeChipsStore as n, FreeChipsStore as o, popupStore as p, gameConfigStore as q, GameConfigStore as r, setHttpClientInterceptors as s, statisticsStore as t, userInfoStore as u, StatisticsStore as v, applicationStore as w, userSettingsStore as x, UserSettingsStore as y, tableBetHistoryStore as z };
